import {
  AuthenticationModels,
  AvenantModels,
  BankRejectReasons,
  CommonModels,
  DocumentModels,
  EmailModels,
  ErrorCode,
  HealthModels,
  PaymentModels,
  PolicyModels,
  QuotationModels,
  RefundModels,
  RequestModels,
  SignatureModels,
  SubStatus,
  TunnelSanteActionModels,
  TunnelSanteCancelActionModels,
  TunnelSanteEventModels,
} from '@wz-models';
import {
  RopFormulaDetailEnum,
  RopRateWithholdingEnum,
} from 'libs/modules/tunnelsante-tunnel/rop/models/rop';

import FragmentStateEnum = DocumentModels.FragmentStateEnum;
import PolicyActionType = TunnelSanteActionModels.PolicyActionType;
import CancelActionType = TunnelSanteCancelActionModels.CancelActionTypeEnum;
import AccountKind = CommonModels.AccountKind;
import AagContext = CommonModels.AagContext;
import InsurerSlipType = CommonModels.InsurerSlipType;
import PolicyJobStatusEnum = PolicyModels.PolicyJobStatusEnum;
import InstanceReasonEnum = PolicyModels.InstanceReasonEnum;
import EmailTemplateCategory = EmailModels.EmailTemplateCategory;
import RenewalBehavior = CommonModels.RenewalBehavior;
import AccountStatus = AuthenticationModels.AccountStatus;

const DOC_MAPPING = {
  $ENUM_MAPPING: DocumentModels.DocumentType,
  [DocumentModels.DocumentType.Orias]: 'Attestation Orias',
  [DocumentModels.DocumentType.KBIS]: 'Kbis (-3 mois)',
  [DocumentModels.DocumentType.RibIban]: 'RIB/IBAN',
  [DocumentModels.DocumentType.Others]: 'Autres',
  [DocumentModels.DocumentType.Unassigned]: 'N/A',
  [DocumentModels.DocumentType.SignedAgencyContract]: 'Contrat signé',
  [DocumentModels.DocumentType.AgencyContract]: 'Contrat non signé',
  [DocumentModels.DocumentType.Quotation]: 'Devis',
  [DocumentModels.DocumentType.Attestation]: 'Attestation',
  [DocumentModels.DocumentType.CarteGrise]: 'Carte Grise',
  [DocumentModels.DocumentType.CarteVerte]: 'Carte Verte',
  [DocumentModels.DocumentType.PermisDeConduire]: 'Permis de conduire',
  [DocumentModels.DocumentType.ReleveInformation]: "Relevé d'information",
  [DocumentModels.DocumentType.ConditionsGenerales]: 'Conditions générales',
  [DocumentModels.DocumentType.NoticeLetter]: 'Mise en demeure',
  [DocumentModels.DocumentType.AgencySlip]: "Bordereau d'agence",
  [DocumentModels.DocumentType.ConditionsParticulieres]:
    'Conditions particulières',
  [DocumentModels.DocumentType.Sinister]: 'Sinistre',
  [DocumentModels.DocumentType.ReleveInformationTunnelSante]:
    'Releve Information TunnelSante',
  [DocumentModels.DocumentType.TerminationRequest]: 'Demande de résiliation',
  [DocumentModels.DocumentType.TerminationReject]: 'Refus de résiliation',
  [DocumentModels.DocumentType.TerminationLetter]: 'Lettre de résiliation',
  [DocumentModels.DocumentType.RemiseEnVigueurLetter]:
    'Lettre de remise en vigueur',
  [DocumentModels.DocumentType.AvenantRequest]: "Demande d'avenant",
  [DocumentModels.DocumentType.TableauDeGaranties]: 'Tableau des garanties',
  [DocumentModels.DocumentType.NoticeInformation]: "Notice d'information",
  [DocumentModels.DocumentType.MembershipApplication]: "Demande d'adhésion",
  [DocumentModels.DocumentType.FicheIpid]: 'Fiche IPID',
  [DocumentModels.DocumentType.SignedMembershipApplication]:
    "Demande d'adhésion signée",
  [DocumentModels.DocumentType.ConsultingSheet]: "Fiche d'information",
  [DocumentModels.DocumentType.HealthSocialSecurityCertificate]:
    'Attestation de sécurité sociale',
  [DocumentModels.DocumentType.CarteIdentite]: "Carte d'identité",
  [DocumentModels.DocumentType.SubscriptionCertificate]:
    "Certificat d'adhésion",
  [DocumentModels.DocumentType.RenewalNotice]: "Avis d'échéance",
  [DocumentModels.DocumentType.RenewalReject]:
    "Résiliation à échéance par l'assureur",
  [DocumentModels.DocumentType.AvenantReject]: "Refus d'avenant",
  [DocumentModels.DocumentType.SignedQuotation]: "Bulletin d'adhésion signé",
  [DocumentModels.DocumentType.PhotoVehicule]: 'Photo véhicule',
  [DocumentModels.DocumentType.InsurerSlipRecap]: 'InsurerSlipRecap',
  [DocumentModels.DocumentType.SignedAutoCp]:
    'Conditions particulières signées',
  [DocumentModels.DocumentType.DeclarationFiscale]: 'Déclaration fiscale',
  [DocumentModels.DocumentType.Echeancier]: 'Echéancier',
  [DocumentModels.DocumentType.CarteVerteFondVert]: 'Carte Verte Fond Vert',
  [DocumentModels.DocumentType.Lettre]: 'Lettre',
  [DocumentModels.DocumentType.HealthAvenant]: 'Avenant Santé',
  [DocumentModels.DocumentType.ThirdPartyPayerCard]: 'Carte de tiers payant',
  [DocumentModels.DocumentType.BankReject]: 'Rejet de prélèvement',
  [DocumentModels.DocumentType.DueNotice]: "Avis d'échéance",
  [DocumentModels.DocumentType.LoiMadelin]: 'Loi Madelin',
  [DocumentModels.DocumentType.RadiationCertification]:
    'Certificat de radiation',
  [DocumentModels.DocumentType.StatusChangeLetter]:
    'Lettre Changement de Statut',
  [DocumentModels.DocumentType.MandatSepa]: 'Mandat Sepa',
  [DocumentModels.DocumentType.Proto]: 'Protocole rémunération',
  [DocumentModels.DocumentType.MandatResiliationPolicy]:
    'Mandat de résilisation',
  [DocumentModels.DocumentType.SignedMandatResiliationPolicy]:
    'Mandat de résilisation signé',
};
export const enumResources = {
  HEALTH_AVENANT_ENUM: {
    $ENUM_MAPPING: CommonModels.HealthAvenantType,
    [CommonModels.HealthAvenantType.CHANGE_ADDRESS]: "Changement d'adresse",
    [CommonModels.HealthAvenantType.CHANGE_NAME]: 'Changement de nom',
    [CommonModels.HealthAvenantType.CHANGE_WARRANTY]: 'Changement de garantie',
    [CommonModels.HealthAvenantType.MODIFY_MAIN_BENEFICIARY]:
      'Modification assuré principal',
    [CommonModels.HealthAvenantType.REPLACE_MAIN_BENEFICIARY]:
      'Remplacement assuré principal',
    [CommonModels.HealthAvenantType.ADD_BENEFICIARY]: 'Rajout assuré',
    [CommonModels.HealthAvenantType.CHANGE_BENEFICIARY]: 'Modification assuré',
    [CommonModels.HealthAvenantType.REMOVE_BENEFICIARY]: 'Retrait assuré',
    [CommonModels.HealthAvenantType.CHANGE_SOCIALSYSTEM]:
      'Changement de régime obligatoire',
    [CommonModels.HealthAvenantType.CHANGE_PAYMENT]: 'Changement IBAN',
    [CommonModels.HealthAvenantType.REDUCTION]: 'Réduction commerciale',
    [CommonModels.HealthAvenantType.SPLIT_CONTRACT]: 'Séparation de contrat',
  },

  RENEWAL_BEHAVIOUR_ENUM: {
    $ENUM_MAPPING: RenewalBehavior,
    [RenewalBehavior.Mantien]: 'Mantien',
    [RenewalBehavior.Termination]: 'Resiliation',
  },

  AGENCY_STATUS_ENUM: {
    $ENUM_MAPPING: CommonModels.AgencyStatusEnum,
    [CommonModels.AgencyStatusEnum.Validated]: 'Agence validée',
    [CommonModels.AgencyStatusEnum.Subscription]: 'Souscription',
    [CommonModels.AgencyStatusEnum.WaitingSignature]: 'Signature en att.',
    [CommonModels.AgencyStatusEnum.Archived]: 'Agence archivée',
  },
  ANCIENNETE_CONTRAT_ENUM: {
    $ENUM_MAPPING: QuotationModels.AncienneteContratEnum,
    [QuotationModels.AncienneteContratEnum.PlusUnAn]: "Plus d'un an",
    [QuotationModels.AncienneteContratEnum.MoinsUnAn]: "Moins d'un an",
  },
  AVENANT_TYPE_ENUM: {
    $ENUM_MAPPING: AvenantModels.AvenantTypeEnum,
    [AvenantModels.AvenantTypeEnum.InformationsAssure]:
      "Changement des informations de contact de l'assuré",
    [AvenantModels.AvenantTypeEnum.ChangementVehicule]:
      'Changement de véhicule',
  },
  AVENANT_TYPE_ENUM_GESTION: {
    $ENUM_MAPPING: AvenantModels.AvenantTypeEnumGestion,
    [AvenantModels.AvenantTypeEnumGestion.ChangementGarantie]:
      'Changement de garantie',
    [AvenantModels.AvenantTypeEnumGestion.ChangementDateEffet]:
      "Changement de date d'effet",
    [AvenantModels.AvenantTypeEnumGestion.Immatriculation]:
      'Changement d immatriculation',
    [AvenantModels.AvenantTypeEnumGestion.UsageVehicule]: 'Changement usage',
    [AvenantModels.AvenantTypeEnumGestion.Antecedants]:
      "Antécédants d'assurance",
  },
  BOITE_DE_VITESSE_ENUM: {
    $ENUM_MAPPING: QuotationModels.BoiteDeVitesseEnum,
    [QuotationModels.BoiteDeVitesseEnum.Automatique]: 'Automatique',
    [QuotationModels.BoiteDeVitesseEnum.Manuelle]: 'Manuelle',
  },
  BENEFICIARY_ENUM: {
    $ENUM_MAPPING: HealthModels.BeneficiaryTypeEnum,
    [HealthModels.BeneficiaryTypeEnum.You]: 'Assuré principal',
    [HealthModels.BeneficiaryTypeEnum.Partner]: 'Conjoint',
  },

  PAYMENTORDER_TYPE_ENUM: {
    $ENUM_MAPPING: PaymentModels.PaymentOrderType,
    [PaymentModels.PaymentOrderType.Manual]: 'Manual',
    [PaymentModels.PaymentOrderType.CronD4]: 'CronD4',
    [PaymentModels.PaymentOrderType.CronD15]: 'CronD15',
    [PaymentModels.PaymentOrderType.CronD30]: 'CronD30',
  },

  PAYMENT_STATUS_ENUM: {
    $ENUM_MAPPING: PaymentModels.PaymentTransactionStatusEnum,
    [PaymentModels.PaymentTransactionStatusEnum.WaitingPayzen]: 'WaitingPayzen',
    [PaymentModels.PaymentTransactionStatusEnum.Abandoned]: 'Abandoned',
    [PaymentModels.PaymentTransactionStatusEnum.Authorised]: 'Authorised',
    [PaymentModels.PaymentTransactionStatusEnum.Captured]: 'Captured',
    [PaymentModels.PaymentTransactionStatusEnum.Refused]: 'Refused',
    [PaymentModels.PaymentTransactionStatusEnum.Canceled]: 'Canceled',
  },

  JOBSTATUS_ENUM: {
    $ENUM_MAPPING: EmailModels.JobStatusEnum,
    [EmailModels.JobStatusEnum.Submitted]: 'A traiter',
    [EmailModels.JobStatusEnum.InProgress]: 'En cours',
    [EmailModels.JobStatusEnum.Processed]: 'Traité',
    [EmailModels.JobStatusEnum.Validated]: 'Validé',
    [EmailModels.JobStatusEnum.Rejected]: 'Rejeté',
    [EmailModels.JobStatusEnum.InError]: 'En erreur',
    [EmailModels.JobStatusEnum.Sent]: 'Envoyé',
  },

  POLICY_HOLDER_ENUM: {
    $ENUM_MAPPING: HealthModels.BeneficiaryTypeEnum,
    [HealthModels.PolicyHolderTypeEnum.AssurePrincipal]: 'Assuré principal',
    [HealthModels.PolicyHolderTypeEnum.Conjoint]: 'Conjoint',
    [HealthModels.PolicyHolderTypeEnum.Enfant]: 'Enfant',
  },

  TERMINATION_CAT_ENUM: {
    $ENUM_MAPPING: HealthModels.TerminationCategoryEnum,
    [HealthModels.TerminationCategoryEnum.Resiliation]: 'Resiliation',
    [HealthModels.TerminationCategoryEnum.SansEffet]: 'Sans Effet',
  },

  CLAIM_REFUND_BENEFICIARY_TYPE_ENUM: {
    $ENUM_MAPPING: RefundModels.ClaimRefundBeneficiaryEnum,
    [RefundModels.ClaimRefundBeneficiaryEnum.Garage]: 'Garage',
    [RefundModels.ClaimRefundBeneficiaryEnum.Client]: 'Client',
    [RefundModels.ClaimRefundBeneficiaryEnum.Prestataire]: 'Prestataire',
    [RefundModels.ClaimRefundBeneficiaryEnum.Autre]: 'Autre',
  },
  TERMINATION_TYPE_ENUM: {
    $ENUM_MAPPING: PolicyModels.TerminationTypeEnum,
    [PolicyModels.TerminationTypeEnum.Hamon]: 'Loi hamon',
    [PolicyModels.TerminationTypeEnum.CarDestroyedOrSold]:
      'Destruction ou cession du véhicule',
    [PolicyModels.TerminationTypeEnum.RefusDeRevalorisation]:
      'Refus de revalorisation',
    [PolicyModels.TerminationTypeEnum.AtCompletion]: 'À échéance',
    [PolicyModels.TerminationTypeEnum.SituationChanged]:
      'Changement de situation',
    [PolicyModels.TerminationTypeEnum.Misc]: 'Divers',
    [PolicyModels.TerminationTypeEnum.Npp]: 'Non paiement de prime',
    [PolicyModels.TerminationTypeEnum.ChangementDeRisque]:
      'Changement de risque',
    [PolicyModels.TerminationTypeEnum.ChangementDeSituationFamiliale]:
      'Changement de situation familiale',
    [PolicyModels.TerminationTypeEnum.Amiable]: 'Amiable',
    [PolicyModels.TerminationTypeEnum.Augmentation]: 'Augmentation',
    [PolicyModels.TerminationTypeEnum.Death]: 'Disparition du risque – Décès',
    [PolicyModels.TerminationTypeEnum.Ria]: 'Résiliation infra-annuelle',
    [PolicyModels.TerminationTypeEnum.ErreurDeSaisie]: 'Erreur De Saisie',
    [PolicyModels.TerminationTypeEnum.Doublon]: 'Doublon',
    [PolicyModels.TerminationTypeEnum.DemandeDuClient]: 'Demande Du Client',
    [PolicyModels.TerminationTypeEnum.DemandeDuCourtier]: 'Demande Du Courtier',
    [PolicyModels.TerminationTypeEnum.Report]: 'Report',
    [PolicyModels.TerminationTypeEnum.AggravationRisque]: 'Aggravation Risque',
    [PolicyModels.TerminationTypeEnum.Résiliationaprèssinistre]:
      'Résiliation après sinistre',
    [PolicyModels.TerminationTypeEnum.Résiliationaggravationdurisque]:
      'Résiliation aggravation du risque',
    [PolicyModels.TerminationTypeEnum.RésiliationéchéanceAssureur]:
      'Résiliation échéance Assureur',
    [PolicyModels.TerminationTypeEnum.Nullité]: 'Nullité',
  },
  CADUCITE_TYPE_ENUM: {
    $ENUM_MAPPING: PolicyModels.CaduciteTypeEnum,
    [PolicyModels.CaduciteTypeEnum.AnciennetePermisHorsChampSouscription]:
      'Ancienneté du permis hors champ de souscription',
    [PolicyModels.CaduciteTypeEnum.AnnulationAdministrative]:
      'Annulation administrative',
    [PolicyModels.CaduciteTypeEnum.AnnulationPermisConduire]:
      'Annulation du permis de conduire',
    [PolicyModels.CaduciteTypeEnum.AucunePieceRecue]: 'Aucune pièce reçue',
    [PolicyModels.CaduciteTypeEnum
      .CoefficientReductionMajorationHorsChampSouscription]:
      'Coefficient réduction majoration hors champ de souscription',
    [PolicyModels.CaduciteTypeEnum.ComplementNonRegle]: 'Complément non réglé',
    [PolicyModels.CaduciteTypeEnum.DelitFuiteDeclare]:
      'Délit de fuite non declaré',
    [PolicyModels.CaduciteTypeEnum.InvalidationPermisConduire]:
      'Invalidation du  permis de conduire',
    [PolicyModels.CaduciteTypeEnum.AgeAssureHorsChampSouscription]:
      "Age de l'assuré hors champ de souscription",
    [PolicyModels.CaduciteTypeEnum.AbsenceCarteGrise]: 'Absence de carte grise',
    [PolicyModels.CaduciteTypeEnum.AbsencePermis]: 'Absence de permis',
    [PolicyModels.CaduciteTypeEnum.AbsenceRIB]: 'Absence  de RIB',
    [PolicyModels.CaduciteTypeEnum.SouscripteurNonTitulaireCarteGrise]:
      'Souscripteur non titulaire de la carte grise',
    [PolicyModels.CaduciteTypeEnum.PermisEtrangerNonTransforme]:
      'Permis étranger non transformé',
    [PolicyModels.CaduciteTypeEnum.PermisNonObtenuEnConduiteAccompagnee]:
      'Permis non obtenu en conduite accompagnée',
    [PolicyModels.CaduciteTypeEnum.PertePermis]: 'Perte de permis',
    [PolicyModels.CaduciteTypeEnum.ProfilRisqueIntarifable]:
      'Profil de risque intarifable',
    [PolicyModels.CaduciteTypeEnum.RefusObtempererNonDeclare]:
      "Refus d'obtempérer non déclaré",
    [PolicyModels.CaduciteTypeEnum.ReleveInformationIncomplet]:
      "Relevé d'information incomplet",
    [PolicyModels.CaduciteTypeEnum.SinistreHorsChampSouscription]:
      'Sinistre hors champ de souscription',
    [PolicyModels.CaduciteTypeEnum.SinistreNonDeclare]: 'Sinistre non déclaré',
    [PolicyModels.CaduciteTypeEnum.SuspensionPermisConduire]:
      'Suspension du permis de conduire',
    [PolicyModels.CaduciteTypeEnum.UsageVehiculeExclu]:
      'Usage du véhicule exclu',
    [PolicyModels.CaduciteTypeEnum.VéhiculeHorsChampSouscription]:
      'Véhicule hors champ de souscription',
    [PolicyModels.CaduciteTypeEnum.ZoneCirculationExclue]:
      'Zone de circulation exclue',
  },
  CARROSSERIE_ENUM: {
    $ENUM_MAPPING: QuotationModels.CarrosserieEnum,
    [QuotationModels.CarrosserieEnum.Berline]: 'Berline',
    [QuotationModels.CarrosserieEnum.Berline_3_Portes]: 'Berline 3 portes',
    [QuotationModels.CarrosserieEnum.Berline_4_Portes]: 'Berline 4 portes',
    [QuotationModels.CarrosserieEnum.Berline_5_Portes]: 'Berline 5 portes',
    [QuotationModels.CarrosserieEnum.Break]: 'Break',
    [QuotationModels.CarrosserieEnum.Break_3_Portes]: 'Break 3 portes',
    [QuotationModels.CarrosserieEnum.Break_4_Portes]: 'Break 4 portes',
    [QuotationModels.CarrosserieEnum.Break_5_Portes]: 'Break 5 portes',
    [QuotationModels.CarrosserieEnum.Cabriolet]: 'Cabriolet',
    [QuotationModels.CarrosserieEnum.Camionnette]: 'Camionnette',
    [QuotationModels.CarrosserieEnum.Chassis_Cabine]: 'Chassis cabine',
    [QuotationModels.CarrosserieEnum.Chassis_Double_Cabine]:
      'Chassis double cabine',
    [QuotationModels.CarrosserieEnum.Chassis_Nu]: 'Chassis nu',
    [QuotationModels.CarrosserieEnum.Combi]: 'Combi',
    [QuotationModels.CarrosserieEnum.Commercial_3_Portes]:
      'Commercial 3 portes',
    [QuotationModels.CarrosserieEnum.Commercial_5_Portes]:
      'Commercial 5 portes',
    [QuotationModels.CarrosserieEnum.Commercial_Break]: 'Commercial break',
    [QuotationModels.CarrosserieEnum.Commerciale]: 'Commerciale',
    [QuotationModels.CarrosserieEnum.Coupe]: 'Coupe',
    [QuotationModels.CarrosserieEnum.Divers]: 'Divers',
    [QuotationModels.CarrosserieEnum.Familial]: 'Familial',
    [QuotationModels.CarrosserieEnum.Fourgon]: 'Fourgon',
    [QuotationModels.CarrosserieEnum.Fourgonnette]: 'Fourgonnette',
    [QuotationModels.CarrosserieEnum.Limousine]: 'Limousine',
    [QuotationModels.CarrosserieEnum.Ludospace]: 'Ludospace',
    [QuotationModels.CarrosserieEnum.Minibus]: 'Minibus',
    [QuotationModels.CarrosserieEnum.Monospace]: 'Monospace',
    [QuotationModels.CarrosserieEnum.Pick_Up]: 'Pick up',
    [QuotationModels.CarrosserieEnum.Pick_Up_Double_Cabine]:
      'Pick up double cabine',
    [QuotationModels.CarrosserieEnum.Plancher_Cabine]: 'Plancher cabine',
    [QuotationModels.CarrosserieEnum.Plateau_Cabine]: 'Plateau cabine',
    [QuotationModels.CarrosserieEnum.Plateau_Double_Cabine]:
      'Plateau double cabine',
    [QuotationModels.CarrosserieEnum.Plateau_Ridelles]: 'Plateau ridelles',
    [QuotationModels.CarrosserieEnum.Tous_Terrains]: 'Tous terrains',
    [QuotationModels.CarrosserieEnum.Vehicule_Tout_Chemin]:
      'Vehicule tout chemin',
  },
  CIVILITY_ENUM: {
    $ENUM_MAPPING: CommonModels.CivilityEnum,
    [CommonModels.CivilityEnum.Homme]: 'Monsieur',
    [CommonModels.CivilityEnum.Femme]: 'Madame',
  },
  CIVILITY_SHORT_ENUM: {
    $ENUM_MAPPING: CommonModels.CivilityEnum,
    [CommonModels.CivilityEnum.Homme]: 'M.',
    [CommonModels.CivilityEnum.Femme]: 'Mme.',
  },
  COMPANY_TYPE_ENUM: {
    $ENUM_MAPPING: CommonModels.CompanyTypeEnum,
    [CommonModels.CompanyTypeEnum.EI]:
      'Entreprise Individuelle (EI) pas de Capital Social',
    [CommonModels.CompanyTypeEnum.EURL]:
      'Entreprise Unipersonnelle à Responsabilité Limitée (EURL)',
    [CommonModels.CompanyTypeEnum.SARL]:
      'Societé à Responsabilité Limitée (SARL)',
    [CommonModels.CompanyTypeEnum.SA]: 'Societé Anonyme (SA)',
    [CommonModels.CompanyTypeEnum.SASU]:
      'Societé par Actions Simplifiée Unipersonnelle (SASU)',
    [CommonModels.CompanyTypeEnum.SAS]: 'Societé par Actions Simplifiée (SAS)',
    [CommonModels.CompanyTypeEnum.SNC]: 'Societé en Nom Collectif (SNC)',
  },
  DOCUMENT_STATE_ENUM: {
    $ENUM_MAPPING: DocumentModels.DocumentStateEnum,
    [DocumentModels.DocumentStateEnum.Full]: 'Complet',
    [DocumentModels.DocumentStateEnum.Incomplete]: 'Incomplet',
    [DocumentModels.DocumentStateEnum.ToProcess]: 'A traiter',
    [DocumentModels.DocumentStateEnum.NotFound]: 'Aucun document',
    [DocumentModels.DocumentStateEnum.Archived]: 'Archivé',
  },
  DOCUMENT_TYPE_ENUM: { ...DOC_MAPPING },
  ROP_DOCUMENT_TYPE_ENUM: {
    ...DOC_MAPPING,
    [DocumentModels.DocumentType.Quotation]: "Bulletin d'adhésion",
    [DocumentModels.DocumentType.SignedQuotation]: "Bulletin d'adhésion signé",
  },
  DUREE_SUSPENSION_ENUM: {
    $ENUM_MAPPING: QuotationModels.DureeSuspensionEnum,
    [QuotationModels.DureeSuspensionEnum.None]: 'Aucune',
    [QuotationModels.DureeSuspensionEnum.De1A3Mois]: 'De 1 à 3 mois',
    [QuotationModels.DureeSuspensionEnum.De4A6Mois]: 'De 4 à 6 mois',
    [QuotationModels.DureeSuspensionEnum.De7A12Mois]: 'De 7 à 12 mois',
    [QuotationModels.DureeSuspensionEnum.De13A24Mois]: 'De 13 à 24 mois',
    [QuotationModels.DureeSuspensionEnum.PlusDe24Mois]: 'Plus de 24 mois',
  },
  ENERGIE_ENUM: {
    $ENUM_MAPPING: QuotationModels.EnergieEnum,
    [QuotationModels.EnergieEnum.BioEthanol]: 'Bio ethanol',
    [QuotationModels.EnergieEnum.Electrique]: 'Electrique',
    [QuotationModels.EnergieEnum.Essence]: 'Essence',
    [QuotationModels.EnergieEnum.Gasoil]: 'Gasoil',
    [QuotationModels.EnergieEnum.GazNaturelDeVille]: 'Gaz naturel de ville',
    [QuotationModels.EnergieEnum.Gpl]: 'Gpl',
  },
  FINANCEMENT_ENUM: {
    $ENUM_MAPPING: QuotationModels.FinancementEnum,
    [QuotationModels.FinancementEnum.Comptant]: 'Comptant',
    [QuotationModels.FinancementEnum.Credit]: 'Crédit',
    [QuotationModels.FinancementEnum.Donation]: 'Donation',
    [QuotationModels.FinancementEnum.Leasing]: 'Leasing',
  },
  ROP_LEVEL_ENUM: {
    $ENUM_MAPPING: QuotationModels.FormulaEnum,
    [QuotationModels.FormulaEnum.Rop20]: '20 €',
    [QuotationModels.FormulaEnum.Rop30]: '30 €',
    [QuotationModels.FormulaEnum.Rop40]: '40 €',
    [QuotationModels.FormulaEnum.Rop50]: '50 €',
    [QuotationModels.FormulaEnum.Rop60]: '60 €',
  },
  FORMULA_ENUM: {
    $ENUM_MAPPING: QuotationModels.FormulaEnum,
    [QuotationModels.FormulaEnum.Basic]: 'Tiers simple',
    [QuotationModels.FormulaEnum.Confort]: 'Tiers confort',
    [QuotationModels.FormulaEnum.AllInclusive]: 'Tous risques',
    [QuotationModels.FormulaEnum.Sante1]: 'Formule Santé 1',
    [QuotationModels.FormulaEnum.Sante2]: 'Formule Santé 2',
    [QuotationModels.FormulaEnum.Sante3]: 'Formule Santé 3',
    [QuotationModels.FormulaEnum.Sante4]: 'Formule Santé 4',
    [QuotationModels.FormulaEnum.Sante5]: 'Formule Santé 5',
    [QuotationModels.FormulaEnum.Sante6]: 'Formule Santé 6',
    [QuotationModels.FormulaEnum.Sante7]: 'Formule Santé 7',
    [QuotationModels.FormulaEnum.Rop20]: 'Formule 1 (20€)',
    [QuotationModels.FormulaEnum.Rop30]: 'Formule 2 (30€)',
    [QuotationModels.FormulaEnum.Rop40]: 'Formule 3 (40€)',
    [QuotationModels.FormulaEnum.Rop50]: 'Formule 4 (50€)',
    [QuotationModels.FormulaEnum.Rop60]: 'Formule 5 (60€)',
  },
  FORMULA_SHORT_ENUM: {
    $ENUM_MAPPING: QuotationModels.FormulaEnum,
    [QuotationModels.FormulaEnum.Basic]: 'Tiers simple',
    [QuotationModels.FormulaEnum.Confort]: 'Tiers confort',
    [QuotationModels.FormulaEnum.AllInclusive]: 'Tous risques',
    [QuotationModels.FormulaEnum.Sante1]: 'F1',
    [QuotationModels.FormulaEnum.Sante2]: 'F2',
    [QuotationModels.FormulaEnum.Sante3]: 'F3',
    [QuotationModels.FormulaEnum.Sante4]: 'F4',
    [QuotationModels.FormulaEnum.Sante5]: 'F5',
    [QuotationModels.FormulaEnum.Sante6]: 'F6',
    [QuotationModels.FormulaEnum.Sante7]: 'F7',
  },
  FROM_PAYZEN_STATUS_ENUM: {
    $ENUM_MAPPING: PaymentModels.FromPayzenStatus,
    [PaymentModels.FromPayzenStatus.Cancelled]: 'Le paiement a été abandonné',
    [PaymentModels.FromPayzenStatus.Error]: 'Une erreur est survenue',
    [PaymentModels.FromPayzenStatus.Refused]: 'Le paiement a été refusé',
    [PaymentModels.FromPayzenStatus.Success]: 'Le paiement a bien été réalisé',
  },
  GARAGE_ENUM: {
    $ENUM_MAPPING: QuotationModels.GarageEnum,
    [QuotationModels.GarageEnum.GarageFerme]: 'Garage fermé',
    [QuotationModels.GarageEnum.GaragePublicSurveille]:
      'Garage public surveillé',
    [QuotationModels.GarageEnum.JardinClosPrive]: 'Jardin clos privé',
    [QuotationModels.GarageEnum.ParkingCollectifPleinAir]:
      'Parking collectif plein air',
    [QuotationModels.GarageEnum.ParkingFermeCollectif]:
      'Parking fermé collectif',
    [QuotationModels.GarageEnum.VoiePublique]: 'Voie publique',
  },
  GRAMMES_MESURE_ALCOOLEMIE_ENUM: {
    $ENUM_MAPPING: QuotationModels.GrammeMesureAlcoolemieEnum,
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre50Et79]:
      'Entre 0.50 et 0.79 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre80Et100]:
      'Entre 0.80 et 1.00 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre101Et125]:
      'Entre 1.01 et 1.25 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre126Et150]:
      'Entre 1.26 et 1.5 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre151Et175]:
      'Entre 1.51 et 1.75 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre176Et200]:
      'Entre 1.76 et 2 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre200Et225]:
      'Entre 2.01 et 2.25 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre226Et250]:
      'Entre 2.26 et 2.50 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre251Et275]:
      'Entre 2.51 et 2.75 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.Entre276Et300]:
      'Entre 2.76 et 3 g/L de sang',
    [QuotationModels.GrammeMesureAlcoolemieEnum.PlusDe300]:
      'De plus de 3 g/L de sang',
  },
  HEALTH_RATE_LINEAR_ENUM: {
    $ENUM_MAPPING: HealthModels.HealthRateLinearEnum,
    [HealthModels.HealthRateLinearEnum.L1]: '16 %',
    [HealthModels.HealthRateLinearEnum.L2]: '18 %',
    [HealthModels.HealthRateLinearEnum.L3]: '11 %',
    [HealthModels.HealthRateLinearEnum.L4]: '15 %',
    [HealthModels.HealthRateLinearEnum.L5]: '6 %',
    [HealthModels.HealthRateLinearEnum.L6]: '10 %',
    [HealthModels.HealthRateLinearEnum.L7]: '20 %',
    [HealthModels.HealthRateLinearEnum.L8]: '15 %',
    [HealthModels.HealthRateLinearEnum.L9]: '10 %',

    [HealthModels.HealthRateLinearEnum.L_22_16]: '16 % Éco',
    [HealthModels.HealthRateLinearEnum.L_22_18]: '18 % Éco',
    [HealthModels.HealthRateLinearEnum.L_24_16]: '16 %',
    [HealthModels.HealthRateLinearEnum.L_24_18]: '18 %',
    [HealthModels.HealthRateLinearEnum.L_24_20]: '20 %',

    [HealthModels.HealthRateLinearEnum.FIDELITY_L_24_16]: '16 %',
    [HealthModels.HealthRateLinearEnum.FIDELITY_L_24_18]: '18 %',
    [HealthModels.HealthRateLinearEnum.FIDELITY_L_24_20]: '20 %',

    [HealthModels.HealthRateLinearEnum.ACHEEL_L1]: '16 %',
    [HealthModels.HealthRateLinearEnum.ACHEEL_L2]: '18 %',
    [HealthModels.HealthRateLinearEnum.ACHEEL_L7]: '20 %',
  },
  HEALTH_RATE_WITHHOLD_ENUM: {
    $ENUM_MAPPING: HealthModels.HealthRateWithholdingEnum,
    [HealthModels.HealthRateWithholdingEnum.PR1]: '32/10',
    [HealthModels.HealthRateWithholdingEnum.PR2]: '42/10',
    [HealthModels.HealthRateWithholdingEnum.PR3]: '45/10',
    [HealthModels.HealthRateWithholdingEnum.PR4]: '25/20',
    [HealthModels.HealthRateWithholdingEnum.PR5]: '35/10',
    [HealthModels.HealthRateWithholdingEnum.PR6]: '37/10',
    [HealthModels.HealthRateWithholdingEnum.PR7]: '40/10',

    [HealthModels.HealthRateWithholdingEnum.PR_25_15_16]: '25/15/16',
    [HealthModels.HealthRateWithholdingEnum.PR_27_15_16]: '27/15/16',
    [HealthModels.HealthRateWithholdingEnum.PR_30_15_17]: '30/15/17',
    [HealthModels.HealthRateWithholdingEnum.PR_32_16_17]: '32/16/17',
    [HealthModels.HealthRateWithholdingEnum.PR_35_16_17]: '35/16/17',
    [HealthModels.HealthRateWithholdingEnum.PR_37_15_17]: '37/15/17',

    [HealthModels.HealthRateWithholdingEnum.FIDELITY_PR_32_10_10]: '32/10',
    [HealthModels.HealthRateWithholdingEnum.FIDELITY_PR_42_10_10]: '42/10',
    [HealthModels.HealthRateWithholdingEnum.FIDELITY_PR_45_10_10]: '45/10',
    [HealthModels.HealthRateWithholdingEnum.FIDELITY_PR_35_10_10]: '35/10',
    [HealthModels.HealthRateWithholdingEnum.FIDELITY_PR_37_10_10]: '37/10',
    [HealthModels.HealthRateWithholdingEnum.FIDELITY_PR_40_10_10]: '40/10',

    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR1_50_15]: '32/10',
    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR2_50_15]: '42/10',
    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR3_50_15]: '45/10',
    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR4_50_15]: '25/20',
    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR5_50_15]: '35/10',
    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR6_50_15]: '37/10',
    [HealthModels.HealthRateWithholdingEnum.ACHEEL_PR7_50_15]: '40/10',
  },
  HEALTH_RATE_COMMISSION_PAIRS_ENUM: {
    $ENUM_MAPPING: HealthModels.HealthRateCommissionPairsEnum,
    [HealthModels.HealthRateCommissionPairsEnum.L1PR1]:
      'Linéaire: 16 % - Précompte: 32/10',
    [HealthModels.HealthRateCommissionPairsEnum.L2PR2]:
      'Linéaire: 18 % - Précompte: 42/10',
    [HealthModels.HealthRateCommissionPairsEnum.L7PR3]:
      'Linéaire: 20 % - Précompte: 45/10',
    [HealthModels.HealthRateCommissionPairsEnum.L7PR4]:
      'Linéaire: 20 % - Précompte: 25/20',
    [HealthModels.HealthRateCommissionPairsEnum.L1PR5]:
      'Linéaire: 16 % - Précompte: 35/10',
    [HealthModels.HealthRateCommissionPairsEnum.L2PR6]:
      'Linéaire: 18 % - Précompte: 37/10',
    [HealthModels.HealthRateCommissionPairsEnum.L2PR7]:
      'Linéaire: 18 % - Précompte: 40/10',

    [HealthModels.HealthRateCommissionPairsEnum.L_24_16_PR_25_15_16]:
      'Linéaire: 16 % - Précompte: 25/15/16',
    [HealthModels.HealthRateCommissionPairsEnum.L_24_16_PR_27_15_16]:
      'Linéaire: 16 % - Précompte: 27/15/16',
    [HealthModels.HealthRateCommissionPairsEnum.L_24_18_PR_30_15_17]:
      'Linéaire: 18 % - Précompte: 30/15/17',
    [HealthModels.HealthRateCommissionPairsEnum.L_24_18_PR_32_16_17]:
      'Linéaire: 18 % - Précompte: 32/16/17',
    [HealthModels.HealthRateCommissionPairsEnum.L_24_20_PR_35_16_17]:
      'Linéaire: 20 % - Précompte: 35/16/17',
    [HealthModels.HealthRateCommissionPairsEnum.L_24_20_PR_37_15_17]:
      'Linéaire: 20 % - Précompte: 37/15/17',

    [HealthModels.HealthRateCommissionPairsEnum.FidelityL_24_16_PR_32_10]:
      'Linéaire: 16 % - Précompte: 32/10',
    [HealthModels.HealthRateCommissionPairsEnum.FidelityL_24_16_PR_35_10]:
      'Linéaire: 16 % - Précompte: 35/10',
    [HealthModels.HealthRateCommissionPairsEnum.FidelityL_24_18_PR_37_10]:
      'Linéaire: 18 % - Précompte: 37/10',
    [HealthModels.HealthRateCommissionPairsEnum.FidelityL_24_18_PR_40_10]:
      'Linéaire: 18 % - Précompte: 40/10',
    [HealthModels.HealthRateCommissionPairsEnum.FidelityL_24_20_PR_42_10]:
      'Linéaire: 20 % - Précompte: 42/10',
    [HealthModels.HealthRateCommissionPairsEnum.FidelityL_24_20_PR_45_10]:
      'Linéaire: 20 % - Précompte: 45/10',

    [HealthModels.HealthRateCommissionPairsEnum.AcheelL1PR1]:
      'Linéaire: 16 % - Précompte: 32/10',
    [HealthModels.HealthRateCommissionPairsEnum.AcheelL2PR2]:
      'Linéaire: 18 % - Précompte: 42/10',
    [HealthModels.HealthRateCommissionPairsEnum.AcheelL7PR3]:
      'Linéaire: 20 % - Précompte: 45/10',
    [HealthModels.HealthRateCommissionPairsEnum.AcheelL1PR5]:
      'Linéaire: 16 % - Précompte: 35/10',
    [HealthModels.HealthRateCommissionPairsEnum.AcheelL2PR6]:
      'Linéaire: 18 % - Précompte: 37/10',
    [HealthModels.HealthRateCommissionPairsEnum.AcheelL2PR7]:
      'Linéaire: 18 % - Précompte: 40/10',
  },
  HEALTH_CONTACT_TYPE_ENUM: {
    $ENUM_MAPPING: HealthModels.HealthContactTypeEnum,
    [HealthModels.HealthContactTypeEnum.RiskBearingInsurer]:
      'Assureur porteur du risque',
    [HealthModels.HealthContactTypeEnum.Assistant]: 'Assisteur',
    [HealthModels.HealthContactTypeEnum.ServiceManagement]:
      'Gestions des prestations',
  },
  RDV_REASON_ENUM: {
    $ENUM_MAPPING: CommonModels.RdvReasonEnum,
    [CommonModels.RdvReasonEnum.OffersAutos]: 'Les offres Auto',
    [CommonModels.RdvReasonEnum.OffersHealthOrIJH]:
      'Les offres Santé / Prévoyance',
    [CommonModels.RdvReasonEnum.FormationExtranetTool]:
      'Une formation à notre outil extranet TunnelSante',
    [CommonModels.RdvReasonEnum.DigitalHelp]:
      'Une aide à la digitalisation de votre cabinet (site internet / API / CRM)',
    [CommonModels.RdvReasonEnum.SupportDDA]:
      'Un accompagnement à la DDA (comprendre les obligations et vous orienter vers le bon partenaire)',
    [CommonModels.RdvReasonEnum.Other]: 'Autre',
  },

  RDV_PERIOD_ENUM: {
    $ENUM_MAPPING: CommonModels.RdvPeriodEnum,
    [CommonModels.RdvPeriodEnum.Morning]: 'Matinée',
    [CommonModels.RdvPeriodEnum.Afternoon]: 'Après-midi',
  },

  ROP_RATE_WITHHOLD_ENUM: {
    $ENUM_MAPPING: RopRateWithholdingEnum,
    [RopRateWithholdingEnum.PR1]: '70/10',
  },
  INSURANCE_TYPE_ENUM: {
    $ENUM_MAPPING: CommonModels.InsuranceTypeEnum,
    [CommonModels.InsuranceTypeEnum.Auto]: 'Assurance Auto',
    [CommonModels.InsuranceTypeEnum.Sante]: 'Assurance Santé',
    [CommonModels.InsuranceTypeEnum.Rop]: 'Assurance IJH Cashback',
  },
  INSURANCE_CONTRACT_TYPE_ENUM: {
    $ENUM_MAPPING: CommonModels.InsuranceTypeEnum,
    [CommonModels.InsuranceTypeEnum.Auto]: 'Police Auto',
    [CommonModels.InsuranceTypeEnum.Sante]: 'Complémentaire Santé',
    [CommonModels.InsuranceTypeEnum.Rop]: 'IJH Cashback',
  },
  INSURANCE_TYPE_SHORT_ENUM: {
    $ENUM_MAPPING: CommonModels.InsuranceTypeEnum,
    [CommonModels.InsuranceTypeEnum.Auto]: 'Auto',
    [CommonModels.InsuranceTypeEnum.Moto]: 'Moto',
    [CommonModels.InsuranceTypeEnum.Habitation]: 'Habitation',
    [CommonModels.InsuranceTypeEnum.Permis]: 'Permis',
    [CommonModels.InsuranceTypeEnum.PanneMecanique]: 'Panne mécanique',
    [CommonModels.InsuranceTypeEnum.Sante]: 'Sante',
  },
  QUITTANCEMENT_ENUM: {
    $ENUM_MAPPING: QuotationModels.QuittancementEnum,
    [QuotationModels.QuittancementEnum.Annuel]: 'Annuel',
    [QuotationModels.QuittancementEnum.Mois]: 'Mensuel',
  },
  QUITTANCEMENT_SHORT_ENUM: {
    $ENUM_MAPPING: QuotationModels.QuittancementEnum,
    [QuotationModels.QuittancementEnum.Annuel]: 'An',
    [QuotationModels.QuittancementEnum.Mois]: 'Mois',
  },
  QUOTATION_STATUS_ENUM: {
    $ENUM_MAPPING: QuotationModels.QuotationStatusEnum,
    [QuotationModels.QuotationStatusEnum.WaitingPayzen]:
      'En attente de paiement',
    [QuotationModels.QuotationStatusEnum.Paid]: "Création de l'espace client",
    [QuotationModels.QuotationStatusEnum.WaitingSignature]:
      'En attente de signature',
    [QuotationModels.QuotationStatusEnum.Signed]: "Demande d'adhésion signée",
    [QuotationModels.QuotationStatusEnum.InProgress]: 'Devis en attente',
    [QuotationModels.QuotationStatusEnum.Archived]: 'Archivé',
  },
  LITRES_MESURE_ALCOOLEMIE_ENUM: {
    $ENUM_MAPPING: QuotationModels.LitresMesureExpireEnum,
    [QuotationModels.LitresMesureExpireEnum.Entre250et399]:
      "Entre 0.25 et 0.39 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre400et500]:
      "Entre 0.40 et 0.50 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre501Et620]:
      "Entre 0.50 et 0.62 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre630Et750]:
      "Entre 0.63 et 0.75 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre760Et870]:
      "Entre 0.76 et 0.87 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre880Et1000]:
      "Entre 0.88 et 1 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre1010Et1120]:
      "Entre 1.01 et 1.12 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre1130Et1250]:
      "Entre 1.13 et 1.25 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre1260Et1370]:
      "Entre 1.26 et 1.37 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.Entre1380Et1500]:
      "Entre 1.38 et 1.50 mg/L d'air expiré",
    [QuotationModels.LitresMesureExpireEnum.PlusDe1500]:
      "De plus de 1.5 mg/L d'air expiré",
  },
  NATURE_SINISTRE_ENUM: {
    $ENUM_MAPPING: QuotationModels.NatureSinistreEnum,
    [QuotationModels.NatureSinistreEnum.Corporel]: 'Corporel',
    [QuotationModels.NatureSinistreEnum.Materiel]: 'Matériel',
    DEFAULT: 'Non défini',
  },
  NOMBRE_KILOMETRES_ANNUEL_ENUM: {
    $ENUM_MAPPING: QuotationModels.NombreKilometresAnnuelEnum,
    [QuotationModels.NombreKilometresAnnuelEnum.De0A4999]: 'De 0 à 4999 km',
    [QuotationModels.NombreKilometresAnnuelEnum.De5000A7999]:
      'De 5000 à 7999 km',
    [QuotationModels.NombreKilometresAnnuelEnum.De8000A11999]:
      'De 8000 à 11999 km',
    [QuotationModels.NombreKilometresAnnuelEnum.De12000A15999]:
      'De 12000 à 15999 km',
    [QuotationModels.NombreKilometresAnnuelEnum.De16000A24999]:
      'De 16000 à 24999 km',
    [QuotationModels.NombreKilometresAnnuelEnum.De25000A34999]:
      'De 25000 à 34999 km',
    [QuotationModels.NombreKilometresAnnuelEnum.PlusDe35000]:
      'Plus de 35000 km',
  },
  NULLITE_TYPE_ENUM: {
    $ENUM_MAPPING: PolicyModels.NulliteTypeEnum,
    [PolicyModels.NulliteTypeEnum.AnciennetePermisHorsChampSouscription]:
      'Ancienneté du permis hors champ de souscription',
    [PolicyModels.NulliteTypeEnum.AnnulationAdministrative]:
      'Annulation administrative',
    [PolicyModels.NulliteTypeEnum.AnnulationPermisConduire]:
      'Annulation du permis de conduire',
    [PolicyModels.NulliteTypeEnum.AucunePieceRecue]: 'Aucune pièce reçue',
    [PolicyModels.NulliteTypeEnum
      .CoefficientReductionMajorationHorsChampSouscription]:
      'Coefficient réduction majoration hors champ de souscription',
    [PolicyModels.NulliteTypeEnum.ComplementNonRegle]: 'Complément non réglé',
    [PolicyModels.NulliteTypeEnum.DelitFuiteDeclare]:
      'Délit de fuite non declaré',
    [PolicyModels.NulliteTypeEnum.InvalidationPermisConduire]:
      'Invalidation du  permis de conduire',
    [PolicyModels.NulliteTypeEnum.AgeAssureHorsChampSouscription]:
      "Age de l'assuré hors champ de souscription",
    [PolicyModels.NulliteTypeEnum.AbsenceCarteGrise]: 'Absence de carte grise',
    [PolicyModels.NulliteTypeEnum.AbsencePermis]: 'Absence de permis',
    [PolicyModels.NulliteTypeEnum.AbsenceRIB]: 'Absence  de RIB',
    [PolicyModels.NulliteTypeEnum.SouscripteurNonTitulaireCarteGrise]:
      'Souscripteur non titulaire de la carte grise',
    [PolicyModels.NulliteTypeEnum.PermisEtrangerNonTransforme]:
      'Permis étranger non transformé',
    [PolicyModels.NulliteTypeEnum.PermisNonObtenuEnConduiteAccompagnee]:
      'Permis non obtenu en conduite accompagnée',
    [PolicyModels.NulliteTypeEnum.PertePermis]: 'Perte de permis',
    [PolicyModels.NulliteTypeEnum.ProfilRisqueIntarifable]:
      'Profil de risque intarifable',
    [PolicyModels.NulliteTypeEnum.RefusObtempererNonDeclare]:
      "Refus d'obtempérer non déclaré",
    [PolicyModels.NulliteTypeEnum.ReleveInformationIncomplet]:
      "Relevé d'information incomplet",
    [PolicyModels.NulliteTypeEnum.SinistreHorsChampSouscription]:
      'Sinistre hors champ de souscription',
    [PolicyModels.NulliteTypeEnum.SinistreNonDeclare]: 'Sinistre non déclaré',
    [PolicyModels.NulliteTypeEnum.SuspensionPermisConduire]:
      'Suspension du permis de conduire',
    [PolicyModels.NulliteTypeEnum.UsageVehiculeExclu]:
      'Usage du véhicule exclu',
    [PolicyModels.NulliteTypeEnum.VéhiculeHorsChampSouscription]:
      'Véhicule hors champ de souscription',
    [PolicyModels.NulliteTypeEnum.ZoneCirculationExclue]:
      'Zone de circulation exclue',
  },
  PAYMENT_STATUS_REASON_ENUM: {
    $ENUM_MAPPING: PaymentModels.PaymentTransactionReasonEnum,
    DEFAULT: 'Payement refusé',
    [PaymentModels.PaymentTransactionReasonEnum
      .TransactionApprouveeOuTraiteeAvecSucces]: 'Transaction approuvée',
    [PaymentModels.PaymentTransactionReasonEnum.ContacterEmetteurDeCarte]:
      "Contacter l'émetteur de la carte",
    [PaymentModels.PaymentTransactionReasonEnum.AccepteurInvalide]:
      'Accepteur invalide',
    [PaymentModels.PaymentTransactionReasonEnum.ConserverLaCarte]:
      'Conserver la carte',
    [PaymentModels.PaymentTransactionReasonEnum.NePasHonorer]:
      'Votre demande de paiement a été refusée par votre établissement financier',
    [PaymentModels.PaymentTransactionReasonEnum
      .ConserverLaCarteConditionsSpeciales]:
      'Conserver la carte (conditions spéciales)',
    [PaymentModels.PaymentTransactionReasonEnum.ApprouverApresIdentification]:
      'Approuver après identification',
    [PaymentModels.PaymentTransactionReasonEnum.TransactionInvalide]:
      'Transaction invalide',
    [PaymentModels.PaymentTransactionReasonEnum.MontantInvalide]:
      'Montant invalide',
    [PaymentModels.PaymentTransactionReasonEnum.NumeroDePorteurInvalide]:
      'Numéro de porteur invalide',
    [PaymentModels.PaymentTransactionReasonEnum.EmetteurDeCarteInconnu]:
      'Emetteur de carte inconnu',
    [PaymentModels.PaymentTransactionReasonEnum.AnnulationAcheteur]:
      'Annulation acheteur',
    [PaymentModels.PaymentTransactionReasonEnum
      .RepeterLaTransactionUlterieurement]:
      'Répéter la transaction ultérieurement',
    [PaymentModels.PaymentTransactionReasonEnum.ReponseErronee]:
      'Réponse eronnée (erreur serveur)',
    [PaymentModels.PaymentTransactionReasonEnum.MiseAJourDeFichierNonSupportee]:
      'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum
      .ImpossibleDeLocaliserEnregistrementDansLeFichier]: 'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum
      .EnregistrementDupliqueAncienEnregistrementRemplace]: 'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum
      .ErreurEnEditSurChampDeListeaJourFichier]: 'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum.MiseAJourImpossible]:
      'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum.ErreurDeFormat]:
      'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum
      .IdentifiantOrganismeAcquereurInconnu]:
      "Identifiant de l'organisme acquéreur inconnnu",
    [PaymentModels.PaymentTransactionReasonEnum
      .DateDeValiditeDeLaCarteDepassee1]:
      'Date de validité de la carte dépassée',
    [PaymentModels.PaymentTransactionReasonEnum.SuspicionDeFraude1]:
      'Suspicion de fraude',
    [PaymentModels.PaymentTransactionReasonEnum
      .DateDeValiditeDeLaCarteDepassee2]:
      'Date de validité de la carte dépassée',
    [PaymentModels.PaymentTransactionReasonEnum.CartePerdue]: 'Carte perdue',
    [PaymentModels.PaymentTransactionReasonEnum.CarteVolee]: 'Carte volée',
    [PaymentModels.PaymentTransactionReasonEnum
      .ProvisionInsuffisanteOuCreditDepasse]:
      'Provision insuffisante ou plafond dépassé',
    [PaymentModels.PaymentTransactionReasonEnum
      .DateDeValiditeDeLaCarteDepassee3]:
      'Date de validité de la carte dépassée',
    [PaymentModels.PaymentTransactionReasonEnum.CodeConfidentielErrone]:
      'Code confidentiel eronné',
    [PaymentModels.PaymentTransactionReasonEnum.CarteAbsenteDuFichier]:
      'Carte absente du fichier',
    [PaymentModels.PaymentTransactionReasonEnum
      .TransactionNonPermisePorteurFrauduleux]:
      'Transaction non permise à ce porteur',
    [PaymentModels.PaymentTransactionReasonEnum.TransactionNonPermisePorteur]:
      'Transaction non permise à ce porteur',
    [PaymentModels.PaymentTransactionReasonEnum.SuspicionDeFraude2]:
      'Suspicion de fraude',
    [PaymentModels.PaymentTransactionReasonEnum
      .AccepteurDeCarteDoitContacterAcquereur]:
      "L'accepteur de la carte doit contacter l'acquéreur",
    [PaymentModels.PaymentTransactionReasonEnum.MontantDeRetraitHorsLimite]:
      'Montant de retrait hors limite',
    [PaymentModels.PaymentTransactionReasonEnum.ReglesDeSecuriteNonRespectees]:
      'Règles de sécurité non respectées',
    [PaymentModels.PaymentTransactionReasonEnum
      .ReponseNonParvenueOuReçueTropTard]:
      'Réponse non parvenue ou reçue trop tard',
    [PaymentModels.PaymentTransactionReasonEnum
      .NombreEssaisCodeConfidentielDepasse]:
      "Nombre d'essais du code confidentiel dépassé",
    [PaymentModels.PaymentTransactionReasonEnum
      .PorteurDejaEnOppositionAncienEnregistrementConserve]:
      'Porteut déja en opposition, ancien enregistrement conservé',
    [PaymentModels.PaymentTransactionReasonEnum.ArretMomentaneDuSysteme]:
      'Arrêt momentané du système',
    [PaymentModels.PaymentTransactionReasonEnum.emetteurDeCartesInaccessible]:
      'Emetteur de cartes inaccessible',
    [PaymentModels.PaymentTransactionReasonEnum.AccesInterditAuFichier]:
      'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum.TransactionDupliquee]:
      'Transaction dupliquée',
    [PaymentModels.PaymentTransactionReasonEnum.MauvaisFonctionnementDuSysteme]:
      'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum
      .echeanceDeLaTemporisationDeSurveillanceGlobale]: 'Erreur serveur',
    [PaymentModels.PaymentTransactionReasonEnum
      .ServeurIndisponibleRoutageReseauDemandeNouveau]:
      'Serveur indisponible, réessayer plus tard',
    [PaymentModels.PaymentTransactionReasonEnum.IncidentDomaineInitiateur]:
      'Erreur serveur',
  },
  PERIODE_ASSURANCE36_DERNIERS_MOIS_ENUM: {
    $ENUM_MAPPING: QuotationModels.PeriodeAssurance36DerniersMoisEnum,
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.PasAssurance]:
      "Pas d'assurance",
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.De1MoisA7Mois]:
      'De 1 à 7 mois',
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.De8Mois11Mois]:
      'De 8 à 11 mois',
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.De12MoisA15Mois]:
      'De 12 à 15 mois',
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.De16MoisA23Mois]:
      'De 16 à 23 mois',
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.De24MoisA35Mois]:
      'De 24 à 35 mois',
    [QuotationModels.PeriodeAssurance36DerniersMoisEnum.SupérieurOuEgale36Mois]:
      'Supérieur ou égal à 36 mois',
  },
  PERIODE_INTERRUPTION_ENUM: {
    $ENUM_MAPPING: QuotationModels.PeriodeInterruptionEnum,
    [QuotationModels.PeriodeInterruptionEnum.Aucun]: "Pas d'interruption",
    [QuotationModels.PeriodeInterruptionEnum.De1A3Mois]: 'De 1 à 3 mois',
    [QuotationModels.PeriodeInterruptionEnum.De4A6Mois]: 'De 4 à 6 mois',
    [QuotationModels.PeriodeInterruptionEnum.PlusDe6Mois]: 'Plus de 6 mois',
  },

  FAQ_CATEGORY: {
    $ENUM_MAPPING: CommonModels.FaqCategory,
    [CommonModels.FaqCategory.Gestion]: 'GESTION',
    [CommonModels.FaqCategory.Adp]: 'ADP – SANTÉ & PRÉVOYANCE',
    [CommonModels.FaqCategory.Iard]: 'IARD – AUTO',
  },

  CONTACT_CATEGORY: {
    $ENUM_MAPPING: CommonModels.ContactCategory,
    [CommonModels.ContactCategory.Animation]: 'Animation',
    [CommonModels.ContactCategory.Gestion]: 'Gestion Santé',
    [CommonModels.ContactCategory.Prestations]: 'Prestations Infinity/Fidelity',
    [CommonModels.ContactCategory.It]: 'It',
    [CommonModels.ContactCategory.PrestationsEcoPlus]: 'Prestations Eco+',
  },

  EMAIl_TEMPLATE_CATEGORY: {
    $ENUM_MAPPING: EmailTemplateCategory,
    [EmailTemplateCategory.SansEffet]: 'SansEffet',
    [EmailTemplateCategory.Resiliation]: 'Resiliation',
    [EmailTemplateCategory.Avenant]: 'Avenant',
    [EmailTemplateCategory.AckSansEffetResilClient]: 'AckSansEffetResilClient',
    [EmailTemplateCategory.InstanceCourtier]: 'InstanceCourtier',
    [EmailTemplateCategory.InstanceClient]: 'InstanceClient',
    [EmailTemplateCategory.Autre]: 'Autre',
    [EmailTemplateCategory.Header]: 'En-tête',
    [EmailTemplateCategory.Signature]: 'Signature',
  },

  PRODUCT_CATEGORY: {
    $ENUM_MAPPING: CommonModels.ProductDocumentationCategory,
    [CommonModels.ProductDocumentationCategory.Auto]: 'Produit Auto',
    [CommonModels.ProductDocumentationCategory.Acheel]: 'Produit Santé : Eco +',
    [CommonModels.ProductDocumentationCategory.Infinity]:
      'Produit Santé : Infinity',
    [CommonModels.ProductDocumentationCategory.Fidelity]:
      'Produit Santé : Fidelity',
    [CommonModels.ProductDocumentationCategory.Rop]: 'Produit prévoyance',
    [CommonModels.ProductDocumentationCategory.All]: 'Tous produits',
    [CommonModels.ProductDocumentationCategory.ProduitsSante]: 'Produits Santé',
    [CommonModels.ProductDocumentationCategory.ADPSantePrevoyance]:
      'ADP : Santé & Prévoyance ',
  },

  HEALTH_POLICY_CHANGE_ENUM: {
    $ENUM_MAPPING: PolicyModels.HelathPolicyChangeEnum,
    [PolicyModels.HelathPolicyChangeEnum.Product]: 'Product',
    [PolicyModels.HelathPolicyChangeEnum.ClientName]: 'NOm du client',
    [PolicyModels.HelathPolicyChangeEnum.ClientAddress1]:
      'Adresse client ligne 1',
    [PolicyModels.HelathPolicyChangeEnum.ClientAddress2]:
      'Adresse client ligne 2',
    [PolicyModels.HelathPolicyChangeEnum.PolicyPublicId]: 'Reference contrat',
    [PolicyModels.HelathPolicyChangeEnum.PolicyEffectDate]: "Date d'effet",
    [PolicyModels.HelathPolicyChangeEnum.Civility]: 'Civilite',
    [PolicyModels.HelathPolicyChangeEnum.Courtier]: 'Courtier',
    [PolicyModels.HelathPolicyChangeEnum.Email]: 'Email',
    [PolicyModels.HelathPolicyChangeEnum.Phone]: 'Phone',
    [PolicyModels.HelathPolicyChangeEnum.Mobile]: 'Mobile',
    [PolicyModels.HelathPolicyChangeEnum.Formule]: 'Formule',
    [PolicyModels.HelathPolicyChangeEnum.CreationDate]: 'Date création',
    [PolicyModels.HelathPolicyChangeEnum.AssurePrincipalLastName]:
      'Nom assuré principal',
    [PolicyModels.HelathPolicyChangeEnum.AssurePrincipalFirstName]:
      'Prénom assuré principal',
    [PolicyModels.HelathPolicyChangeEnum.ConjointLastName]: 'Nom conjoint',
    [PolicyModels.HelathPolicyChangeEnum.ConjointFirstName]: 'Prénom conjoint',
    [PolicyModels.HelathPolicyChangeEnum.ConjointDateOfBirth]:
      'Date naissance conjoint',
    [PolicyModels.HelathPolicyChangeEnum.ConjointNumeroSecuriteSocial]:
      'numéro SS conjoint',
    [PolicyModels.HelathPolicyChangeEnum.ConjointRegimeSocial]:
      'Regime Social Conjoint',
    [PolicyModels.HelathPolicyChangeEnum.Benef1LastName]: 'Nom bénéficiare 1',
    [PolicyModels.HelathPolicyChangeEnum.Benef1FirstName]:
      'Prénom bénéficiare 1',
    [PolicyModels.HelathPolicyChangeEnum.Benef1DateOfBirth]:
      'Date naissance bénéficiare 1',
    [PolicyModels.HelathPolicyChangeEnum.Benef1NumeroSecuriteSocial]:
      'numéro SS bénéficiare 1',
    [PolicyModels.HelathPolicyChangeEnum.Benef1RegimeSocial]:
      'Regime Social bénéficiare 1',
    [PolicyModels.HelathPolicyChangeEnum.Benef2LastName]: 'Nom bénéficiare 2',
    [PolicyModels.HelathPolicyChangeEnum.Benef2FirstName]:
      'Prénom bénéficiare 2',
    [PolicyModels.HelathPolicyChangeEnum.Benef2DateOfBirth]:
      'Date naissance bénéficiare 2',
    [PolicyModels.HelathPolicyChangeEnum.Benef2NumeroSecuriteSocial]:
      'numéro SS bénéficiare 2',
    [PolicyModels.HelathPolicyChangeEnum.Benef2RegimeSocial]:
      'Regime Social bénéficiare 2',
    [PolicyModels.HelathPolicyChangeEnum.Benef3LastName]: 'Nom bénéficiare 3',
    [PolicyModels.HelathPolicyChangeEnum.Benef3FirstName]:
      'Prénom bénéficiare 3',
    [PolicyModels.HelathPolicyChangeEnum.Benef3DateOfBirth]:
      'Date naissance bénéficiare 3',
    [PolicyModels.HelathPolicyChangeEnum.Benef3NumeroSecuriteSocial]:
      'numéro SS bénéficiare 3',
    [PolicyModels.HelathPolicyChangeEnum.Benef3RegimeSocial]:
      'Regime Social bénéficiare 3',
    [PolicyModels.HelathPolicyChangeEnum.Benef4LastName]: 'Nom bénéficiare 4',
    [PolicyModels.HelathPolicyChangeEnum.Benef4FirstName]:
      'Prénom bénéficiare 4',
    [PolicyModels.HelathPolicyChangeEnum.Benef4DateOfBirth]:
      'Date naissance bénéficiare 4',
    [PolicyModels.HelathPolicyChangeEnum.Benef4NumeroSecuriteSocial]:
      'numéro SS bénéficiare 4',
    [PolicyModels.HelathPolicyChangeEnum.Benef4RegimeSocial]:
      'Regime Social bénéficiare 4',
    [PolicyModels.HelathPolicyChangeEnum.AssurePrincipalDateOfBirth]:
      'Date naissance assuré principal',
    [PolicyModels.HelathPolicyChangeEnum.AssurePrincipalNumeroSecuriteSocial]:
      'numéro SS assuré principal',
    [PolicyModels.HelathPolicyChangeEnum.AssurePrincipalRegimeSocial]:
      'Regime Social  assuré principal',
    [PolicyModels.HelathPolicyChangeEnum.ContractStartDate]: "Date d'effet",
  },
  POLICY_CHANGE_ENUM: {
    $ENUM_MAPPING: PolicyModels.PolicyChangeEnum,
    [PolicyModels.PolicyChangeEnum.FirstName]: 'Prénom',
    [PolicyModels.PolicyChangeEnum.LastName]: 'Nom',
    [PolicyModels.PolicyChangeEnum.Email]: 'Email',
    [PolicyModels.PolicyChangeEnum.Phone]: 'Téléphone fixe',
    [PolicyModels.PolicyChangeEnum.Mobile]: 'Mobile',
    [PolicyModels.PolicyChangeEnum.Immatriculation]: 'Immatriculation',
    [PolicyModels.PolicyChangeEnum.CodeGta]: 'Véhicule',
    [PolicyModels.PolicyChangeEnum.ParkingNuit]: 'Code INSEE Parking nuit',
    [PolicyModels.PolicyChangeEnum.ParkingJour]: 'Code INSEE Parking jour',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalBonus]:
      'Bonus du conducteur principal',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalDateNaissance]:
      'Date de naissance du conducteur principal',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalDatePermis]:
      "Date d'obtention du permis du conducteur principal",
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalTypePermis]:
      'Type de permis du conducteur principal',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalSituationFamiliale]:
      'Situation familiale du conducteur principal',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalProfession]:
      'Profession du conducteur principal',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalNombreEnfants]:
      "Nombre d'enfants du conducteur principal",
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalInterruptionAssurance]:
      'Interruption du conducteur principal',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalNombreAnneeAssurance]:
      "Nombre d'années d'assurance du conducteur principal",
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalnombreAnneeBonus50]:
      "Nombre d'années de bonus à 50",
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalPeriodeAssurance]:
      "Periode d'assurance du conducteur principal",
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalRaisonResiliation]:
      'Raison de résiliation du conducteur principal',
    [PolicyModels.PolicyChangeEnum.Staggering]: 'Fractionnement',
    [PolicyModels.PolicyChangeEnum.TitulaireCarteGrise]:
      'Titulaire de la carte grise',
    [PolicyModels.PolicyChangeEnum.CodePostalPerso]: 'Code postal',
    [PolicyModels.PolicyChangeEnum.CodePostalPro]: 'Code postal pro',
    [PolicyModels.PolicyChangeEnum.AssureCivilite]: 'Civilité',
    [PolicyModels.PolicyChangeEnum.AssureAddress]: "Adresse de l'assuré",
    [PolicyModels.PolicyChangeEnum.OptionnalWarranties]:
      'Garanties optionnelles',
    [PolicyModels.PolicyChangeEnum.Formula]: 'Formule',
    [PolicyModels.PolicyChangeEnum.ConducteurPrincipalSinistres]: 'Sinistres',
    [PolicyModels.PolicyChangeEnum.UsageDuVehicule]: 'Usage du véhicule',
    [PolicyModels.PolicyChangeEnum.Stationnement]: 'Stationnement du véhicule',
    [PolicyModels.PolicyChangeEnum.Financement]: 'Financement du véhicule',
    [PolicyModels.PolicyChangeEnum.KilometrageAnnuel]: 'Kilométrage annuel',
    [PolicyModels.PolicyChangeEnum.VehiculeDejaAssure]:
      'Le véhicule est-il déja assuré ?',
    [PolicyModels.PolicyChangeEnum.DateMiseEnCirculation]:
      'Date de première mise en circulation',
    [PolicyModels.PolicyChangeEnum.DateAchat]: "Date d'achat du véhicule",
    [PolicyModels.PolicyChangeEnum.DateEffet]: "Date d'effet de la Police",
    [PolicyModels.PolicyChangeEnum.ChargementCourtier]:
      'Taux chargement courtier',
    [PolicyModels.PolicyChangeEnum.ContractStartDate]: "Date d'effet",
  },
  RECEIPT_STATE_ENUM: {
    $ENUM_MAPPING: PolicyModels.ReceiptStateEnum,
    [PolicyModels.ReceiptStateEnum.Issued]: 'Émis',
    [PolicyModels.ReceiptStateEnum.Paid]: 'Payé',
    [PolicyModels.ReceiptStateEnum.Canceled]: 'Annulé',
    [PolicyModels.ReceiptStateEnum.Rejected]: 'Rejeté',
    [PolicyModels.ReceiptStateEnum.Refunded]: 'Remboursé',
    [PolicyModels.ReceiptStateEnum.PendingRefund]: 'Émis',
  },

  FRAGMENT_STATE_ENUM: {
    $ENUM_MAPPING: FragmentStateEnum,
    [FragmentStateEnum.Handled]: 'Géré',
    [FragmentStateEnum.IsLoading]: 'En cours',
    [FragmentStateEnum.NotHandled]: 'Non géré',
    [FragmentStateEnum.Rejected]: 'Archivé',
  },

  BANK_REJECT_REASON_ENUM: {
    $ENUM_MAPPING: PolicyModels.BankRejectReasonEnum,
    [PolicyModels.BankRejectReasonEnum.IncorrectAccountNumber]:
      "AC01 - Coordonnées bancaires incorrectes: IBAN/BIC incorrecte ou le compte n'est pas en euro.",
    [PolicyModels.BankRejectReasonEnum.InvalidCreditorAccountNumber]:
      'AC03 - Numéro de compte créancier invalide',
    [PolicyModels.BankRejectReasonEnum.ClosedAccountNumber]:
      'AC04 - Compte clôturé',
    [PolicyModels.BankRejectReasonEnum.BlockedAccount]:
      'AC06 - Opposition sur compte / Compte bloqué',
    [PolicyModels.BankRejectReasonEnum.InvalidDebtorAccountType]:
      'AC13 - Type de compte débiteur invalide',
    [PolicyModels.BankRejectReasonEnum.InvalidAgent]:
      "AC14 - Un agent dans la chaîne de paiement n'est pas valable.",
    [PolicyModels.BankRejectReasonEnum.AccountDetailsChanged]:
      'AC15 - Les détails du compte ont changé.',
    [PolicyModels.BankRejectReasonEnum.AccountInSequestration]:
      'AC16 - Le compte est sous séquestre.',
    [PolicyModels.BankRejectReasonEnum.AccountInLiquidation]:
      'AC17 - Le compte est en liquidation.',
    [PolicyModels.BankRejectReasonEnum.TransactionForbidden]:
      'AG01 - Opération interdite sur ce type de compte',
    [PolicyModels.BankRejectReasonEnum.InvalidBankOperationCode]:
      'AG02 - Code opération incorrect',
    [PolicyModels.BankRejectReasonEnum.ZeroAmount]: 'AM01 - Montant à zéro',
    [PolicyModels.BankRejectReasonEnum.NotAllowedAmount]:
      'AM02 - Montant supérieur au maximum autorisé',
    [PolicyModels.BankRejectReasonEnum.NotAllowedCurrency]:
      'AM03 - Devise non autorisée',
    [PolicyModels.BankRejectReasonEnum.InsufficientFunds]:
      'AM04 - Fonds insuffisants',
    [PolicyModels.BankRejectReasonEnum.Duplication]: 'AM05 - Doublon',
    [PolicyModels.BankRejectReasonEnum.TooLowAmount]:
      'AM06 - Montant inférieur au minimum autorisé',
    [PolicyModels.BankRejectReasonEnum.BlockedAmount]: 'AM07 - Montant bloqué',
    [PolicyModels.BankRejectReasonEnum.WrongAmount]: 'AM09 - Montant incorrect',
    [PolicyModels.BankRejectReasonEnum.InvalidControlSum]:
      'AM10 - Somme de contrôle invalide',
    [PolicyModels.BankRejectReasonEnum.AlreadyReturnedTransaction]:
      'ARDT - Transaction déjà retournée',
    [PolicyModels.BankRejectReasonEnum.InconsistenWithEndCustomer]:
      'BE01 - Incohérent par rapport au client final',
    [PolicyModels.BankRejectReasonEnum.MissingCreditorAddress]:
      'BE04 - Adresse du créancier manquante',
    [PolicyModels.BankRejectReasonEnum.UnrecognisedInitiatingParty]:
      'BE05 - Emetteur non reconnu',
    [PolicyModels.BankRejectReasonEnum.UnknownEndCustomer]:
      'BE06 - Client final inconnu',
    [PolicyModels.BankRejectReasonEnum.MissingDebtorAddress]:
      'BE07 - Adresse ou dette manquante',
    [PolicyModels.BankRejectReasonEnum.BankError]:
      "BE08 - Renvoyé à la suite d'une erreur bancaire.",
    [PolicyModels.BankRejectReasonEnum.AuthorisationCancelled]:
      "CN01 - L'autorisation est annulée.",
    [PolicyModels.BankRejectReasonEnum.CreditorBankIsNotRegistered]:
      'CNOR - La banque créancière n’est pas agréée',
    [PolicyModels.BankRejectReasonEnum.IncorrectCurrency]:
      'CURR - Devise incorrecte',
    [PolicyModels.BankRejectReasonEnum.RequestedByCustomer]:
      'CUST - Demandé par le client',
    [PolicyModels.BankRejectReasonEnum.DebtorBankIsNotRegistered]:
      'DNOR -  Dette ou la banque n’est pas agréée',
    [PolicyModels.BankRejectReasonEnum.ReturnForTechnicalReason]:
      'DS28 - Retour suite à des problèmes techniques ayant entraîné une transaction erronée.',
    [PolicyModels.BankRejectReasonEnum.InvalidDate]: 'DT01 - Date invalide',
    [PolicyModels.BankRejectReasonEnum.CorrespondentBankNotPossible]:
      'ED01 - Banque correspondante non possible',
    [PolicyModels.BankRejectReasonEnum.BalanceInfoRequest]:
      'ED03 - Requête sur les informations du solde',
    [PolicyModels.BankRejectReasonEnum.SettlementFailed]:
      'ED05 - Règlement échoué',
    [PolicyModels.BankRejectReasonEnum.EmvLiabilityShift]:
      'EMVL - Transfert de responsabilité EMV',
    [PolicyModels.BankRejectReasonEnum.EriOptionNotSupported]:
      "ERIN - L'option Extended Remittance Information (ERI) n'est pas prise en charge.",
    [PolicyModels.BankRejectReasonEnum.InvalidFormat]: 'FF01 - Format invalide',
    [PolicyModels.BankRejectReasonEnum.InvalidLocalInstrumentCode]:
      'FF05 - Type de prélèvement incorrect',
    [PolicyModels.BankRejectReasonEnum.FollowingCancellationRequest]:
      'FOCR - Requête suivant une annulation',
    [PolicyModels.BankRejectReasonEnum.Fraud]:
      "FR01 - Retourné à la suite d'une fraude.",
    [PolicyModels.BankRejectReasonEnum.FinalResponseMandateCancelled]:
      'FRTR - La réponse finale/le suivi est rappelé lorsque le mandat est annulé.',
    [PolicyModels.BankRejectReasonEnum.NoMandate]: 'MD01 - Absence de mandat',
    [PolicyModels.BankRejectReasonEnum.MissingMandatoryInformationInMandate]:
      'MD02 - Données mandat manquantes ou incorrectes',
    [PolicyModels.BankRejectReasonEnum.RefundRequestByEndCustomer]:
      'MD06 - Opération contestée par le débiteur',
    [PolicyModels.BankRejectReasonEnum.EndCustomerDeceased]:
      'MD07 - Titulaire décédé',
    [PolicyModels.BankRejectReasonEnum.NotSpecifiedReasonCustomerGenerated]:
      'MS02 - Refus du destinataire - raison non communiquée',
    [PolicyModels.BankRejectReasonEnum.NotSpecifiedReasonAgentGenerated]:
      'MS03 - Raison non communiquée',
    [PolicyModels.BankRejectReasonEnum.Narrative]: 'NARR - Narratif',
    [PolicyModels.BankRejectReasonEnum.NoAnswerFromCustomer]:
      'NOAS  - Pas de réponse du client',
    [PolicyModels.BankRejectReasonEnum.NotCompliant]:
      "NOCM - Le compte du client n'est pas conforme aux exigences réglementaires, par exemple la FICA (en Afrique du Sud) ou toute autre exigence réglementaire qui rend un compte inactif pour certains traitements.",
    [PolicyModels.BankRejectReasonEnum.NoOriginalTransactionReceived]:
      'NOOR - Pas de transaction originale reçue',
    [PolicyModels.BankRejectReasonEnum.PinLiabilityShift]:
      'PINL - Transfert de responsabilité PIN',
    [PolicyModels.BankRejectReasonEnum.BankIdentifierIncorrect]:
      'RC01 - Code banque incorrect',
    [PolicyModels.BankRejectReasonEnum.InvalidCreditorBicIdentifier]:
      'RC07 - Identifiant BIC du créancier invalide',
    [PolicyModels.BankRejectReasonEnum.NotUniqueTransactionReference]:
      'RF01 - Référence de transaction non unique',
    [PolicyModels.BankRejectReasonEnum.MissingDebtorAccountOrIdentification]:
      'RR01 - Motif réglementaire - compte du débiteur nécessaire',
    [PolicyModels.BankRejectReasonEnum.MissingDebtorNameOrAddress]:
      'RR02 - Motif réglementaire - nom du débiteur nécessaire',
    [PolicyModels.BankRejectReasonEnum.MissingCreditorNameOrAddress]:
      'RR03 - Motif réglementaire - nom du créancier nécessaire',
    [PolicyModels.BankRejectReasonEnum.RegulatoryReason]:
      'RR04 - Motif réglementaire',
    [PolicyModels.BankRejectReasonEnum.ReturnUponUnableToApply]:
      "RUTA - Retour suite à une demande d'enquête et aucune réparation possible.",
    [PolicyModels.BankRejectReasonEnum.SpecificServiceOfferedByDebtorAgent]:
      'SL01 - Service spécifique proposé par la banque du débiteur',
    [PolicyModels.BankRejectReasonEnum.SpecificServiceOfferedByCreditorAgent]:
      'SL02 - Service spécifique offert par la banque du créancier',
    [PolicyModels.BankRejectReasonEnum.CreditorNotOnWhitelistOfDebtor]:
      'SL11 - Compte du créancier absent de la whitelist du débiteur.',
    [PolicyModels.BankRejectReasonEnum.CreditorOnBlacklistOfDebtor]:
      'SL12 - Compte du créancier présent sur la blacklist du débiteur.',
    [PolicyModels.BankRejectReasonEnum
      .MaximumNumberOfDirectDebitTransactionsExceeded]:
      "SL13 - Nombre d'opération de prélèvement maximum autorisé par la banque du débiteur.",
    [PolicyModels.BankRejectReasonEnum
      .MaximumDirectDebitTransactionAmountExceeded]:
      'SL14 - Nombre de transaction maximum autorisé par la banque du débiteur.',
    [PolicyModels.BankRejectReasonEnum.PaymentStopped]:
      'SP01 - Le paiement est arrêté par le titulaire du compte.',
    [PolicyModels.BankRejectReasonEnum.PreviouslyStopped]:
      "SP02 - Précédemment arrêté au moyen d'un avis d'arrêt de paiement.",
    [PolicyModels.BankRejectReasonEnum.ServiceNotRendered]:
      'SVNR - Service non rendu',
    [PolicyModels.BankRejectReasonEnum.CutOffTime]:
      "TM01 - Fichier reçu après l'heure limite",
    [PolicyModels.BankRejectReasonEnum.RemovedFromTracking]:
      "TRAC - Le retour à la suite d'un prélèvement automatique est retiré du processus de suivi.",
    [PolicyModels.BankRejectReasonEnum.UnduePayment]:
      'UPAY - Le paiement est injustifié',
  },
  RECEIPT_TYPE_ENUM: {
    $ENUM_MAPPING: PolicyModels.ReceiptTypeEnum,
    [PolicyModels.ReceiptTypeEnum.FraisDeDossier]: 'Frais de dossier',
    [PolicyModels.ReceiptTypeEnum.Acompte]: 'Acompte',
    [PolicyModels.ReceiptTypeEnum.Quittance]: 'Quittance',
    [PolicyModels.ReceiptTypeEnum.QuittanceDeRejet]: 'Quittance représentée',
    [PolicyModels.ReceiptTypeEnum.QuittanceDePerception]:
      'Quittance de perception',
    [PolicyModels.ReceiptTypeEnum.QuittanceDeRemboursement]:
      'Quittance de remboursement',
    [PolicyModels.ReceiptTypeEnum.QuittanceMoinsPercuComptant]:
      'Quittance de moins perçu ',
    [PolicyModels.ReceiptTypeEnum.QuittanceTropPercuComptant]:
      'Quittance de trop perçu',
    [PolicyModels.ReceiptTypeEnum.QuittanceDeComplement]:
      'Quittance de complément',
    [PolicyModels.ReceiptTypeEnum.QuittanceAnnulation]:
      "Quittance d'annulation",
    [PolicyModels.ReceiptTypeEnum.FraisFinGarantieProvisoire]:
      'Frais fin de garantie provisoire',
    [PolicyModels.ReceiptTypeEnum.QuittanceDeRemboursementSinistre]:
      'Quittance de remboursement sinistre',
    [PolicyModels.ReceiptTypeEnum.QuittanceDeRegularisation]:
      'Quittance de régularisation',
    [PolicyModels.ReceiptTypeEnum.QuittanceAnnulationRegularisation]:
      'Quittance annulation de régularisation',
    [PolicyModels.ReceiptTypeEnum.FraisDeDossierTunnelSante]:
      'Frais de dossier TunnelSante',
  },
  REQUEST_STATE_ENUM: {
    $ENUM_MAPPING: RequestModels.RequestStateEnum,
    DEFAULT: '---',
    [RequestModels.RequestStateEnum.Requested]: 'A traiter',
    [RequestModels.RequestStateEnum.Accepted]: 'Acceptée',
    [RequestModels.RequestStateEnum.Rejected]: 'Rejetée',
    [RequestModels.RequestStateEnum.Handled]: 'Gérée',
    [RequestModels.RequestStateEnum.Cancelled]: 'Annulée',
    [RequestModels.RequestStateEnum.Temporary]: 'Temporaire',
    [RequestModels.RequestStateEnum.PreAccepted]: 'Pré-accepté',
    [RequestModels.RequestStateEnum.Processing]: 'En cours',
    [RequestModels.RequestStateEnum.Error]: 'Erreur',
    [RequestModels.RequestStateEnum.Suspended]: 'Suspendue',
  },
  REQUEST_TYPE_ENUM: {
    $ENUM_MAPPING: RequestModels.RequestTypeEnum,
    [RequestModels.RequestTypeEnum.Termination]: 'Résiliation',
    [RequestModels.RequestTypeEnum.Avenant]: 'Avenant',
    [RequestModels.RequestTypeEnum.MonthlySlips]: 'Bordereaux',
  },
  ROP_FORMULA_DETAIL_ENUM: {
    $ENUM_MAPPING: RopFormulaDetailEnum,
    [RopFormulaDetailEnum.HospiSuiteMaladie]:
      "Montant de l'indemnité journalière",
    [RopFormulaDetailEnum.HospiSuiteAccident]: 'Hospitalisation suite accident',
  },

  POLICY_JOB_STATUS_ENUM: {
    $ENUM_MAPPING: PolicyJobStatusEnum,
    [PolicyJobStatusEnum.Todo]: 'A faire',
    [PolicyJobStatusEnum.Controlled]: 'Controlé',
    [PolicyJobStatusEnum.Instance]: 'Instance',
  },

  INSTANCE_REASON_ENUM: {
    $ENUM_MAPPING: InstanceReasonEnum,
    DEFAULT: '',
    [InstanceReasonEnum.PriceIncrease]: 'Différence de tarif à la hausse',
    [InstanceReasonEnum.RegimeChange]: 'Différence de régime',
    [InstanceReasonEnum.NoAddress]: 'Adresse absente ou erronée',
    [InstanceReasonEnum.InconsistentSSN]: 'Incohérence n° de SS',
    [InstanceReasonEnum.EffectDate]: "Date d'effet",
    [InstanceReasonEnum.NameInconsistency]: 'Incohérence nom/prenom',
    [InstanceReasonEnum.Doublon]: 'Doublon',
  },

  POLICY_STATE_ENUM: {
    $ENUM_MAPPING: PolicyModels.PolicyStateEnum,
    [PolicyModels.PolicyStateEnum.GarantieProvisoire]: 'Garantie provisoire',
    [PolicyModels.PolicyStateEnum.FinDeGarantieProvisoire]:
      'Fin de garantie provisoire',
    [PolicyModels.PolicyStateEnum.EnCours]: 'Police Active',
    [PolicyModels.PolicyStateEnum.Traitement]: 'Traitement',
    [PolicyModels.PolicyStateEnum.MisEnDemeure]: 'Mise en demeure',
    [PolicyModels.PolicyStateEnum.Suspendue]: 'Suspendue',
    [PolicyModels.PolicyStateEnum.Resilie]: 'Résiliée',
    [PolicyModels.PolicyStateEnum.ActifAvecRejet]: 'Actif avec rejet',
    [PolicyModels.PolicyStateEnum.TraitementAvenant]: 'Traitement Avenant',
    [PolicyModels.PolicyStateEnum.Caducite]: 'Caducité',
    [PolicyModels.PolicyStateEnum.Nullite]: 'Nullité',
    [PolicyModels.PolicyStateEnum.ActifAttentePiece]:
      'Police active en attente de pièce',
    [PolicyModels.PolicyStateEnum.SansEffet]: 'Sans effet',
    [PolicyModels.PolicyStateEnum.ValidationEnAttente]: 'Validation en attente',
  },
  PROFESSION_ENUM: {
    $ENUM_MAPPING: QuotationModels.ProfessionEnum,
    [QuotationModels.ProfessionEnum.Agriculteur]: 'Agriculteur',
    [QuotationModels.ProfessionEnum.Artisan]: 'Artisan',
    [QuotationModels.ProfessionEnum.Autre]: 'Autre',
    [QuotationModels.ProfessionEnum.ChefDEntreprise]: "Chef d'entreprise",
    [QuotationModels.ProfessionEnum.Commercant]: 'Commerçant',
    [QuotationModels.ProfessionEnum.Enseignant]: 'Enseignant',
    [QuotationModels.ProfessionEnum.Etudiant]: 'Etudiant',
    [QuotationModels.ProfessionEnum.Fonctionnaire]: 'Fonctionnaire',
    [QuotationModels.ProfessionEnum.ProfessionLiberale]: 'Profession libérale',
    [QuotationModels.ProfessionEnum.RechercheEmploi]: "Recherche d'emploi",
    [QuotationModels.ProfessionEnum.Retraite]: 'Retraité',
    [QuotationModels.ProfessionEnum.SalarieCadre]: 'Salarié cadre',
    [QuotationModels.ProfessionEnum.SalarieNonCadre]: 'Salarié non cadre',
    [QuotationModels.ProfessionEnum.SansProfession]: 'Sans profession',
    [QuotationModels.ProfessionEnum.Societe]: 'Société',
  },
  PACKAGE_ENUM: {
    $ENUM_MAPPING: PolicyModels.PackageEnum,
    DEFAULT: 'Non défini',
    [PolicyModels.PackageEnum.Auto_Partance]: 'AXA Partance',
    [PolicyModels.PackageEnum.Auto_RisqueAgrave]: 'Equité Risque Aggravé',
    [PolicyModels.PackageEnum.Auto_Swisslife]: 'SwissLife',
    [PolicyModels.PackageEnum.Auto_Axa110]: 'AXA Partance',
    [PolicyModels.PackageEnum.Auto_AxaRisqueAggrave]: 'AXA Partance',
    [PolicyModels.PackageEnum.Sante_InfinitySante]: 'Miltis',
    [PolicyModels.PackageEnum.Sante_Fidelity]: 'Swisslife',
    [PolicyModels.PackageEnum.Sante_Acheel]: 'Acheel',
    [PolicyModels.PackageEnum.Rop_IjhCashback_Miltis]: 'Miltis',
  },

  PRODUCT_ENUM: {
    $ENUM_MAPPING: PolicyModels.ProductEnum,
    DEFAULT: 'Non défini',
    [PolicyModels.ProductEnum.Axa_Partance]: 'Axa',
    [PolicyModels.ProductEnum.Equite_RisqueAgrave]: 'Equité risque agravé',
    [PolicyModels.ProductEnum.Equite_Standard]: 'Equité standard',
    [PolicyModels.ProductEnum.AxaRisqueAggrave_700]: 'AXA risque agravé',
    [PolicyModels.ProductEnum.SwissLife_600]: 'SwissLife',
    [PolicyModels.ProductEnum.Auto_Axa110]: 'AXA',
    [PolicyModels.ProductEnum.Rop_IjhCashback_Miltis]: 'Miltis',
  },

  AAG_CONTEXT_ENUM: {
    $ENUM_MAPPING: AagContext,
    DEFAULT: 'Non défini',
    [AagContext.TunnelSante]: 'TunnelSante',
    [AagContext.AA]: 'Active',
  },

  INSURER_SLIP_TYPE_ENUM: {
    $ENUM_MAPPING: InsurerSlipType,
    DEFAULT: 'Non défini',
    [InsurerSlipType.Commission]: 'Commission',
    [InsurerSlipType.Encaissement]: 'Encaissement',
  },
  HEALTH_PACKAGE_ENUM: {
    $ENUM_MAPPING: PolicyModels.PackageEnum,
    [PolicyModels.PackageEnum.Sante_InfinitySante]: 'Miltis Infinity',
    [PolicyModels.PackageEnum.Sante_Acheel]: 'Acheel Eco +',
    [PolicyModels.PackageEnum.Sante_Fidelity]: 'Swisslife Fidelity',
  },
  PACKAGE_PRODUCT_ENUM: {
    $ENUM_MAPPING: PolicyModels.PackageEnum,
    [PolicyModels.PackageEnum.Auto_Swisslife]: 'Standard Swisslife',
    [PolicyModels.PackageEnum.Auto_Partance]: 'Standard Axa',
    [PolicyModels.PackageEnum.Auto_RisqueAgrave]: 'Risques Aggravés',
    [PolicyModels.PackageEnum.Auto_Axa110]: 'AXA',
    [PolicyModels.PackageEnum.Auto_AxaRisqueAggrave]: 'AXA Risques Aggravés',
    [PolicyModels.PackageEnum.Sante_InfinitySante]: 'Infinity',
    [PolicyModels.PackageEnum.Sante_Acheel]: 'Eco +',
    [PolicyModels.PackageEnum.Sante_Fidelity]: 'Fidelity',
    [PolicyModels.PackageEnum.Rop_IjhCashback_Miltis]: 'IJH Cashback',
  },
  PAYMENT_MODE_ENUM: {
    $ENUM_MAPPING: PaymentModels.PaymentModeEnum,
    [PaymentModels.PaymentModeEnum.CB]: 'Carte bleue',
    [PaymentModels.PaymentModeEnum.Cheque]: 'Chèque',
    [PaymentModels.PaymentModeEnum.Prelevement]: 'Prélèvement',
    [PaymentModels.PaymentModeEnum.Virement]: 'Virement',
  },
  FIN_GARANTIE_PROVISOIRE_TYPE_ENUM: {
    $ENUM_MAPPING: PolicyModels.FinGarantieProvisoireTypeEnum,
    [PolicyModels.FinGarantieProvisoireTypeEnum
      .AnciennetePermisHorsChampSouscription]:
      'Ancienneté du permis hors champ de souscription',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AnnulationAdministrative]:
      'Annulation administrative',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AnnulationPermisConduire]:
      'Annulation du permis de conduire',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AucunePieceRecue]:
      'Aucune pièce reçue',
    [PolicyModels.FinGarantieProvisoireTypeEnum
      .CoefficientReductionMajorationHorsChampSouscription]:
      'Coefficient réduction majoration hors champ de souscription',
    [PolicyModels.FinGarantieProvisoireTypeEnum.ComplementNonRegle]:
      'Complément non réglé',
    [PolicyModels.FinGarantieProvisoireTypeEnum.DelitFuiteDeclare]:
      'Délit de fuite non declaré',
    [PolicyModels.FinGarantieProvisoireTypeEnum.InvalidationPermisConduire]:
      'Invalidation du  permis de conduire',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AgeAssureHorsChampSouscription]:
      "Age de l'assuré hors champ de souscription",
    [PolicyModels.FinGarantieProvisoireTypeEnum.AbsenceCarteGrise]:
      'Absence de carte grise',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AbsencePermis]:
      'Absence de permis',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AbsenceRIB]: 'Absence  de RIB',
    [PolicyModels.FinGarantieProvisoireTypeEnum
      .SouscripteurNonTitulaireCarteGrise]:
      'Souscripteur non titulaire de la carte grise',
    [PolicyModels.FinGarantieProvisoireTypeEnum.PermisEtrangerNonTransforme]:
      'Permis étranger non transformé',
    [PolicyModels.FinGarantieProvisoireTypeEnum
      .PermisNonObtenuEnConduiteAccompagnee]:
      'Permis non obtenu en conduite accompagnée',
    [PolicyModels.FinGarantieProvisoireTypeEnum.PertePermis]: 'Perte de permis',
    [PolicyModels.FinGarantieProvisoireTypeEnum.ProfilRisqueIntarifable]:
      'Profil de risque intarifable',
    [PolicyModels.FinGarantieProvisoireTypeEnum.RefusObtempererNonDeclare]:
      "Refus d'obtempérer non déclaré",
    [PolicyModels.FinGarantieProvisoireTypeEnum.ReleveInformationIncomplet]:
      "Relevé d'information incomplet",
    [PolicyModels.FinGarantieProvisoireTypeEnum.SinistreHorsChampSouscription]:
      'Sinistre hors champ de souscription',
    [PolicyModels.FinGarantieProvisoireTypeEnum.SinistreNonDeclare]:
      'Sinistre non déclaré',
    [PolicyModels.FinGarantieProvisoireTypeEnum.SuspensionPermisConduire]:
      'Suspension du permis de conduire',
    [PolicyModels.FinGarantieProvisoireTypeEnum.UsageVehiculeExclu]:
      'Usage du véhicule exclu',
    [PolicyModels.FinGarantieProvisoireTypeEnum.VéhiculeHorsChampSouscription]:
      'Véhicule hors champ de souscription',
    [PolicyModels.FinGarantieProvisoireTypeEnum.ZoneCirculationExclue]:
      'Zone de circulation exclue',
    [PolicyModels.FinGarantieProvisoireTypeEnum.CessionVehicule]:
      'Cession du véhicule',
    [PolicyModels.FinGarantieProvisoireTypeEnum
      .NonTransformationDeLaCarteGrise]: 'Non transformation de la carte grise',
    [PolicyModels.FinGarantieProvisoireTypeEnum.AbsenceDePhotosDuVéhicule]:
      'Absence de photos du véhicule',
  },
  REGIME_SOCIAL_ENUM: {
    $ENUM_MAPPING: HealthModels.RegimeSocialEnum,
    [HealthModels.RegimeSocialEnum.General]: 'Général ou Salarié Agricole',
    [HealthModels.RegimeSocialEnum.TNS]: 'TNS',
    [HealthModels.RegimeSocialEnum.Agricole]: 'Exploitant Agricole',
    [HealthModels.RegimeSocialEnum.AlsaceMoselle]: 'Alsace Moselle',

    // [HealthModels.RegimeSocialEnum.CaisseFrancaisEtranger]: "Caisse des Français à l'étranger",
    // [HealthModels.RegimeSocialEnum.HorsSecuriteSociale]: 'Hors Sécurité Sociale'
  },
  RAISON_RESILIATION_ENUM: {
    $ENUM_MAPPING: QuotationModels.RaisonResiliationEnum,
    [QuotationModels.RaisonResiliationEnum.Non]: 'Aucune',
    [QuotationModels.RaisonResiliationEnum.NPPMoins3Mois]:
      'Non paiement de prime depuis moins de 3 mois',
    [QuotationModels.RaisonResiliationEnum.NPP3A6Mois]:
      'Non paiement de prime entre 3 et 6 mois',
    [QuotationModels.RaisonResiliationEnum.NPPPlus6Mois]:
      'Non paiement de prime depuis plus de 6 mois',
    [QuotationModels.RaisonResiliationEnum.Sinistre]: 'Sinistre',
    [QuotationModels.RaisonResiliationEnum.SinistreNPPMoins3Mois]:
      'Sinistre et Non paiement de prime depuis moins de 3 mois',
    [QuotationModels.RaisonResiliationEnum.SinistreNPP3A6Mois]:
      'Sinistre et Non paiement de prime entre 3 et 6 mois',
    [QuotationModels.RaisonResiliationEnum.SinistreNPPPlus6Mois]:
      'Sinistre et Non paiement de prime depuis plus de 6 mois',
    [QuotationModels.RaisonResiliationEnum.SinistreAlcool]:
      "Sinistre et conduite sous l'empire d'un état alcoolique",
    [QuotationModels.RaisonResiliationEnum.SinistreStupefiant]:
      'Sinistre et conduite sous l’emprise de stupéfiant',
    [QuotationModels.RaisonResiliationEnum.FaussesDeclarations]:
      'Fausse déclaration',
    [QuotationModels.RaisonResiliationEnum.NulliteContrat]:
      'Nullité de contrat',
    [QuotationModels.RaisonResiliationEnum.Autres]:
      'Oui, pour une autre raison',
    [QuotationModels.RaisonResiliationEnum.DelitDeFuite]: 'Délit de fuite',
    [QuotationModels.RaisonResiliationEnum.Alcoolemie]:
      "Conduite sous l'emprise d'un état alcoolique",
    [QuotationModels.RaisonResiliationEnum.Stupefiant]:
      'Conduite sous l’emprise de stupéfiant',
    [QuotationModels.RaisonResiliationEnum.DefautPiece]: 'Défaut de pièces',
    [QuotationModels.RaisonResiliationEnum.AggravationRisque]:
      'Aggravation du risque',
  },
  RAISON_SUSPENSION_ANNULATION_ENUM: {
    $ENUM_MAPPING: QuotationModels.RaisonSuspensionAnnulationEnum,
    [QuotationModels.RaisonSuspensionAnnulationEnum.Non]: 'Non',
    [QuotationModels.RaisonSuspensionAnnulationEnum.Alcoolemie]: 'Alcoolémie',
    [QuotationModels.RaisonSuspensionAnnulationEnum
      .AlcoolemieEtGrandExcesVitesse]: 'Alcoolémie et grand excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum
      .AlcoolemieEtPetitExcesVitesse]: 'Alcoolémie et petit excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum.AlcoolemieEtSinistre]:
      'Alcoolémie et sinistre',
    [QuotationModels.RaisonSuspensionAnnulationEnum
      .AlcoolemieEtSinistreEtExcesVitesse]:
      'Alcoolémie et sinistre et excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum.Autre]: 'Autre',
    [QuotationModels.RaisonSuspensionAnnulationEnum.DefautAssurance]:
      "Défaut d'assurance",
    [QuotationModels.RaisonSuspensionAnnulationEnum.Stupefiant]: 'Stupéfiant',
    [QuotationModels.RaisonSuspensionAnnulationEnum.DelitFuite]:
      'Délit de fuite',
    [QuotationModels.RaisonSuspensionAnnulationEnum
      .StupefiantEtGrandExcesVitesse]: 'Stupéfiant et grand excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum
      .StupefiantEtPetitExcesVitesse]: 'Stupéfiant et petit excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum.StupefiantEtSinistre]:
      'Stupéfiant et sinistre',
    [QuotationModels.RaisonSuspensionAnnulationEnum
      .StupefiantEtSinistreEtExcesVitesse]:
      'Stupéfiant et sinistre et excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum.ResistanceOrdrePublic]:
      "Résistance à l'ordre public",
    [QuotationModels.RaisonSuspensionAnnulationEnum.RefusObtemperer]:
      "Refus d'obtempérer",
    [QuotationModels.RaisonSuspensionAnnulationEnum.RetraitTotalDesPoints]:
      'Retrait total de points de permis',
    [QuotationModels.RaisonSuspensionAnnulationEnum.PetitExcesVitesse]:
      'Petit excès de vitesse',
    [QuotationModels.RaisonSuspensionAnnulationEnum.GrandExcesVitesse]:
      'Grand excès de vitesse',
  },
  RAISON_CONDAMNATION_ENUM: {
    $ENUM_MAPPING: QuotationModels.RaisonCondamnation,
    [QuotationModels.RaisonCondamnation.Aucun]: 'Aucun',
    [QuotationModels.RaisonCondamnation.ControleAlcoolemiePositif]:
      "Contrôle d'alcoolémie positif",
    [QuotationModels.RaisonCondamnation.ControleStupefiantPositif]:
      'Contrôle de stupéfiant positif',
    [QuotationModels.RaisonCondamnation.PetitExcesVitesse]:
      'Petit excès de vitesse',
    [QuotationModels.RaisonCondamnation.GrandExcesVitesse]:
      'Grand excès de vitesse',
    [QuotationModels.RaisonCondamnation.DefautAssurance]: "Défaut d'assurance",
    [QuotationModels.RaisonCondamnation.DelitDeFuite]: 'Délit de fuite',
    [QuotationModels.RaisonCondamnation.RefusObtemperer]: "Refus d'obtempérer",
    [QuotationModels.RaisonCondamnation.ResistanceOrdrePublic]:
      "Résistance à l'ordre public",
    [QuotationModels.RaisonCondamnation.Autre]: 'Autre',
  },
  RESPONSABILITE_SINISTRE_ENUM: {
    $ENUM_MAPPING: QuotationModels.ResponsabiliteSinistreEnum,
    DEFAULT: 'Non défini',
    [QuotationModels.ResponsabiliteSinistreEnum.PartiellementResponsable]:
      'Partiellement responsable',
    [QuotationModels.ResponsabiliteSinistreEnum.NonResponsable]:
      'Non responsable',
    [QuotationModels.ResponsabiliteSinistreEnum.Responsable]: 'Responsable',
  },
  REFUND_TYPE_ENUM: {
    $ENUM_MAPPING: RefundModels.RefundTypeEnum,
    [RefundModels.RefundTypeEnum.Autres]: 'Autres',
    [RefundModels.RefundTypeEnum.Avenant]: 'Avenant',
    [RefundModels.RefundTypeEnum.Caducite]: 'Caducité',
    [RefundModels.RefundTypeEnum.FinDeGarantieProvisoire]:
      'Fin de garantie provisoire',
    [RefundModels.RefundTypeEnum.Resiliation]: 'Résiliation',
    [RefundModels.RefundTypeEnum.Claim]: 'Sinistres',
  },
  REQUEST_REJECT_ENUM: {
    $ENUM_MAPPING: RequestModels.RequestRejectEnum,
    [RequestModels.RequestRejectEnum.Autre]: 'Autre ',
    [RequestModels.RequestRejectEnum.DocumentInvalide]: 'Document invalide',
    [RequestModels.RequestRejectEnum.DocumentManquant]: 'Document manquant',
    [RequestModels.RequestRejectEnum.DocumentIllisible]: 'Document illisible',
    [RequestModels.RequestRejectEnum.QuittanceImpayee]: 'Quittance impayée',
    [RequestModels.RequestRejectEnum.ContratDejaResilieNpp]:
      'Contrat résilié pour NPP',
    [RequestModels.RequestRejectEnum.ContratDejaResilieSinistralite]:
      'Déja résilié pour sinistralité',

    [RequestModels.RequestRejectEnum.AncienneteMoinsUnAn]:
      "L'ancienneté est de moins d'un an",
    [RequestModels.RequestRejectEnum.SouscripteurDifferent]:
      'Le souscripteur est différent',
    [RequestModels.RequestRejectEnum.DemandePassantParAssureNonAssureur]:
      "La demande passe par l'assuré et non l'assureur",

    [RequestModels.RequestRejectEnum.LoiChatelHorsDelai]:
      'Loi Chatel Hors délai',
    [RequestModels.RequestRejectEnum.L11312HorsDelai]: 'L133-12 Hors délai',

    [RequestModels.RequestRejectEnum.MotifNonValable]:
      "Le motif n'est pas valable",

    [RequestModels.RequestRejectEnum.AucuneRevalorisation]:
      'Aucune revalorisation effective',
    [RequestModels.RequestRejectEnum.RevalorisationHorsDelai]:
      'Le délai de refus de revalorisation est dépassé',
    [RequestModels.RequestRejectEnum.AugmentationSuiteAMalus]:
      'Augmentation du prix suite à un malus',

    [RequestModels.RequestRejectEnum.VehiculeEnPanne]:
      'Le véhicule est en panne',
    [RequestModels.RequestRejectEnum.NonUtilisationDuVehicule]:
      'Non utilisation du véhicule',
    [RequestModels.RequestRejectEnum.AucunMotif]: 'Aucun motif',
  },
  SEND_MODE_ENUM: {
    $ENUM_MAPPING: SignatureModels.SendModeEnum,
    [SignatureModels.SendModeEnum.Email]: 'Email',
    [SignatureModels.SendModeEnum.Sms]: 'SMS',
  },
  SITUATION_CHANGE_ENUM: {
    $ENUM_MAPPING: PolicyModels.SituationChangeEnum,
    [PolicyModels.SituationChangeEnum.Autre]: 'Autre',
    [PolicyModels.SituationChangeEnum.ChangementDomicile]: 'Déménagement',
    [PolicyModels.SituationChangeEnum.ChangementProfession]: 'Profession',
    [PolicyModels.SituationChangeEnum.ChangementRegimeMatrimonial]:
      'Régime matrimonial',
    [PolicyModels.SituationChangeEnum.ChangementSituationMatrimoniale]:
      'Situation matriomoniale',
    [PolicyModels.SituationChangeEnum.Retraite]: 'Retraite',
  },
  SITUATION_FAMILIALE_ENUM: {
    $ENUM_MAPPING: QuotationModels.SituationFamilialeEnum,
    [QuotationModels.SituationFamilialeEnum.Celibataire]: 'Célibataire',
    [QuotationModels.SituationFamilialeEnum.Concubinage]: 'Concubinage',
    [QuotationModels.SituationFamilialeEnum.Divorce]: 'Divorcé',
    [QuotationModels.SituationFamilialeEnum.Marie]: 'Marié',
    [QuotationModels.SituationFamilialeEnum.Pacse]: 'Pacsé',
    [QuotationModels.SituationFamilialeEnum.Separe]: 'Séparé',
    [QuotationModels.SituationFamilialeEnum.Veuf]: 'Veuf',
  },
  SUSPENSION_ANNULATION_EPOQUE_ENUM: {
    $ENUM_MAPPING: QuotationModels.SuspensionAnnulationEpoqueEnum,
    [QuotationModels.SuspensionAnnulationEpoqueEnum.MoinsDe5ans]:
      'Moins de 5 ans',
    [QuotationModels.SuspensionAnnulationEpoqueEnum.PlusDe5ans]:
      'Plus de 5 ans',
  },
  SUSPENSION_ANNULATION_PERMIS_ENUM: {
    $ENUM_MAPPING: QuotationModels.SuspensionAnnulationPermisEnum,
    [QuotationModels.SuspensionAnnulationPermisEnum.Annulé]: 'Annulé',
    [QuotationModels.SuspensionAnnulationPermisEnum.None]: 'Non',
    [QuotationModels.SuspensionAnnulationPermisEnum.Suspendu]: 'Suspendu',
  },
  TITULAIRE_CARTE_GRISE_ENUM: {
    $ENUM_MAPPING: QuotationModels.TitulaireCarteGriseEnum,
    [QuotationModels.TitulaireCarteGriseEnum.ConducteurPrincipal]:
      'Conducteur principal',
    [QuotationModels.TitulaireCarteGriseEnum
      .ConducteurPrincipalEtConjointOuConcubin]:
      'Conducteur principal ET conjoint ou concubin',
    [QuotationModels.TitulaireCarteGriseEnum.ConjointOuConcubin]:
      'Conjoint ou concubin',
    [QuotationModels.TitulaireCarteGriseEnum.Enfant]: 'Enfant',
    [QuotationModels.TitulaireCarteGriseEnum.Parents]: 'Parents',
    [QuotationModels.TitulaireCarteGriseEnum.ParentsDuConjointConcubin]:
      'Parents du conjoint ou concubin',
    [QuotationModels.TitulaireCarteGriseEnum.Societe]: 'Société',
    [QuotationModels.TitulaireCarteGriseEnum.SocieteDeLeasing]:
      'Société de leasing',
  },
  TYPE_CONDUCTEUR2_ENUM: {
    $ENUM_MAPPING: QuotationModels.TypeConducteur2Enum,
    [QuotationModels.TypeConducteur2Enum.Ami]: 'Ami',
    [QuotationModels.TypeConducteur2Enum.AutreMembreFamille]:
      'Autre membre famille',
    [QuotationModels.TypeConducteur2Enum.ConjointConcubin]: 'Conjoint concubin',
    [QuotationModels.TypeConducteur2Enum.Enfant]: 'Enfant',
    [QuotationModels.TypeConducteur2Enum.Non]: 'Non',
    [QuotationModels.TypeConducteur2Enum.PereMere]: 'Pere mere',
  },
  TYPE_MESURE_ALCOOLEMIE_ENUM: {
    $ENUM_MAPPING: QuotationModels.TypeMesureAlcoolemieEnum,
    [QuotationModels.TypeMesureAlcoolemieEnum.Ethylotest]: 'Ethylotest',
    [QuotationModels.TypeMesureAlcoolemieEnum.PriseDeSang]: 'Prise de sang',
  },
  SINISTER_STATE_ENUM: {
    $ENUM_MAPPING: QuotationModels.SinisterStateEnum,
    [QuotationModels.SinisterStateEnum.Open]: 'Ouvert',
    [QuotationModels.SinisterStateEnum.Closed]: 'Clos',
    [QuotationModels.SinisterStateEnum.Void]: 'Sans effet',
  },
  TYPE_PERMIS_ENUM: {
    $ENUM_MAPPING: QuotationModels.TypePermisEnum,
    [QuotationModels.TypePermisEnum.PermisB]: 'Permis B',
    [QuotationModels.TypePermisEnum.PermisBAvecConduite]:
      'Permis B avec conduite accompagnée',
    [QuotationModels.TypePermisEnum.PermisEtrangerHorsUe]:
      'Permis étranger hors UE',
    [QuotationModels.TypePermisEnum.PermisEtrangerUe]: 'Permis étranger UE',
  },
  TYPE_SINISTRE_ENUM: {
    $ENUM_MAPPING: QuotationModels.TypeSinistreEnum,
    DEFAULT: 'Non défini',
    [QuotationModels.TypeSinistreEnum.BrisDeGlace]: 'Bris de glace',
    [QuotationModels.TypeSinistreEnum.Collision]: 'Collision',
    [QuotationModels.TypeSinistreEnum.EvenementsNaturels]:
      'Evénements naturels',
    [QuotationModels.TypeSinistreEnum.Incendie]: 'Incendie',
    [QuotationModels.TypeSinistreEnum.Stationnement]: 'Stationnement',
    [QuotationModels.TypeSinistreEnum.Vandalisme]: 'Vandalisme',
    [QuotationModels.TypeSinistreEnum.Vol]: 'Vol',
  },
  TYPE_SINISTRE_ENUM_FOR_TUNNEL_APP: {
    $ENUM_MAPPING: QuotationModels.TypeSinistreEnum,
    DEFAULT: 'Non défini',
    [QuotationModels.TypeSinistreEnum.BrisDeGlace]: 'Bris de glace',
    [QuotationModels.TypeSinistreEnum.Collision]: 'Accident Collision',
    [QuotationModels.TypeSinistreEnum.EvenementsNaturels]:
      'Evénements naturels',
    [QuotationModels.TypeSinistreEnum.Incendie]: 'Incendie',
    [QuotationModels.TypeSinistreEnum.Stationnement]: 'Accident Stationnement',
    [QuotationModels.TypeSinistreEnum.Vandalisme]: 'Vandalisme',
    [QuotationModels.TypeSinistreEnum.Vol]: 'Vol',
  },
  UNIVERS_BESOIN_TYPE_ENUM: {
    $ENUM_MAPPING: HealthModels.UniversBesoinTypeEnum,
    [HealthModels.UniversBesoinTypeEnum.Dentaire]: 'Dentaire',
    [HealthModels.UniversBesoinTypeEnum.Hospitalisation]: 'Hospitalisation',
    [HealthModels.UniversBesoinTypeEnum.Auditif]: 'Auditif',
    [HealthModels.UniversBesoinTypeEnum.Optique]: 'Optique',
    [HealthModels.UniversBesoinTypeEnum.Pharmacie]: 'Pharmacie',
    [HealthModels.UniversBesoinTypeEnum.Medecine]: 'Médecine',
    [HealthModels.UniversBesoinTypeEnum.BienEtre]: 'Bien-être',
    [HealthModels.UniversBesoinTypeEnum.AvantageCapitalDC]:
      'Capital décès inclus',
  },
  UNIVERS_BESOIN_QUESTION_ENUM: {
    $ENUM_MAPPING: HealthModels.UniversBesoinTypeEnum,
    [HealthModels.UniversBesoinTypeEnum.Dentaire]:
      '<strong>Dentaire</strong> (soin, prothèse dentaire, orthodontie, implantologie)',
    [HealthModels.UniversBesoinTypeEnum.Hospitalisation]:
      '<strong>Hospitalisation</strong> (médicale, chirurgicale, maternité)',
    [HealthModels.UniversBesoinTypeEnum.Auditif]:
      '<strong>Aides auditives<strong> (appareillage et prothèse)',
    [HealthModels.UniversBesoinTypeEnum.Optique]:
      '<strong>Optique</strong> (équipements verres et montures, lentilles)',
    [HealthModels.UniversBesoinTypeEnum.Pharmacie]:
      '<strong>Soins courants</strong> (généraliste, spécialiste, médicaments prescrits non remboursables)',
    [HealthModels.UniversBesoinTypeEnum.Medecine]:
      '<strong>Médecine douce</strong> (Ostéopathe, Chiropracteur, Diététicien)',
    [HealthModels.UniversBesoinTypeEnum.BienEtre]:
      '<strong>Prévention et Bien-être</strong> (cure thermale, médecine douce)',
    [HealthModels.UniversBesoinTypeEnum.AvantageCapitalDC]:
      '<strong>Capital Décès</strong> (forfait en cas de décès accidentel)',
  },
  USAGE_ENUM: {
    $ENUM_MAPPING: QuotationModels.UsageEnum,
    [QuotationModels.UsageEnum.Prive]: 'Privé',
    [QuotationModels.UsageEnum.PriveEtPro]: 'Privé et professionnel',
    [QuotationModels.UsageEnum.PriveEtTravail]: 'Privé et trajet travail',
    [QuotationModels.UsageEnum.Pro]: 'Tous déplacements',
  },
  VEHICULE_DEJA_ASSURE_ENUM: {
    $ENUM_MAPPING: QuotationModels.VehiculeDejaAssureEnum,
    [QuotationModels.VehiculeDejaAssureEnum.NonDepuisMoinsDe8Jours]:
      'Non, depuis moins de 8 jours',
    [QuotationModels.VehiculeDejaAssureEnum.NonDepuisPlusDe8Jours]:
      'Non, depuis plus de 8 jours',
    [QuotationModels.VehiculeDejaAssureEnum.Oui]: 'Oui',
  },
  WARRANTY_ENUM: {
    $ENUM_MAPPING: QuotationModels.WarrantyEnum,
    [QuotationModels.WarrantyEnum.AmenagementEtAccessoires]:
      'Aménagement et accessoires',
    [QuotationModels.WarrantyEnum.Assistance]: 'Assistance 0 km',
    [QuotationModels.WarrantyEnum.AssistanceAvecVehiculeDeRemplacement]:
      'Assistance 0 km + véhicule de remplacement',
    [QuotationModels.WarrantyEnum.BrisDeGlace]: 'Bris de glace',
    [QuotationModels.WarrantyEnum.CatastropheNaturelle]:
      'Catastrophe naturelle',
    [QuotationModels.WarrantyEnum.CatastropheTechnologique]:
      'Catastrophe technologique',
    [QuotationModels.WarrantyEnum.DefenseRecours]: 'Défense recours',
    [QuotationModels.WarrantyEnum.DommageTousAccidents]:
      'Dommages tous accidents',
    [QuotationModels.WarrantyEnum.EvenementClimatique]: 'Evènement climatique',
    [QuotationModels.WarrantyEnum.GarantieDuConducteur]:
      'Garantie du conducteur',
    [QuotationModels.WarrantyEnum.Incendie]: 'Incendie',
    [QuotationModels.WarrantyEnum.IncendieVol]: 'Incendie vol',
    [QuotationModels.WarrantyEnum.PanneMecanique]: 'Panne mécanique',
    [QuotationModels.WarrantyEnum.ProtectionJuridique]: 'Protection juridique',
    [QuotationModels.WarrantyEnum.ResponsabiliteCivile]:
      'Responsabilité civile',
    [QuotationModels.WarrantyEnum.InfinitySanteEco]: 'Option Éco',
    [QuotationModels.WarrantyEnum.AcheelSanteEco]: 'Option Éco',
    [QuotationModels.WarrantyEnum.AcheelSanteEcoPlus]: 'Option Éco +',
    [QuotationModels.WarrantyEnum.RopAssistanceProtectionJuridique]:
      'Assistance & Protection Juridique',
  },
  WARRANTY_SHORT_ENUM: {
    $ENUM_MAPPING: QuotationModels.WarrantyEnum,
    [QuotationModels.WarrantyEnum.AmenagementEtAccessoires]: 'AMA',
    [QuotationModels.WarrantyEnum.Assistance]: 'ASS',
    [QuotationModels.WarrantyEnum.AssistanceAvecVehiculeDeRemplacement]:
      'ASSVDR',
    [QuotationModels.WarrantyEnum.BrisDeGlace]: 'BDG',
    [QuotationModels.WarrantyEnum.CatastropheNaturelle]: 'CATN',
    [QuotationModels.WarrantyEnum.CatastropheTechnologique]: 'CATT',
    [QuotationModels.WarrantyEnum.DefenseRecours]: 'DR',
    [QuotationModels.WarrantyEnum.DommageTousAccidents]: 'DTA',
    [QuotationModels.WarrantyEnum.EvenementClimatique]: 'EC',
    [QuotationModels.WarrantyEnum.GarantieDuConducteur]: 'GDC',
    [QuotationModels.WarrantyEnum.Incendie]: 'ICD',
    [QuotationModels.WarrantyEnum.IncendieVol]: 'ICDV',
    [QuotationModels.WarrantyEnum.PanneMecanique]: 'PM',
    [QuotationModels.WarrantyEnum.ProtectionJuridique]: 'PJ',
    [QuotationModels.WarrantyEnum.ResponsabiliteCivile]: 'RC',
    [QuotationModels.WarrantyEnum.InfinitySanteEco]: 'ECO',
    [QuotationModels.WarrantyEnum.AcheelSanteEco]: 'ECO',
    [QuotationModels.WarrantyEnum.AcheelSanteEcoPlus]: 'ECO+',
  },
  WARRANTY_DESCRIPTION_ENUM: {
    $ENUM_MAPPING: QuotationModels.WarrantyDescriptionEnum,
    DEFAULT: '',
    [QuotationModels.WarrantyDescriptionEnum.InfinitySanteEcoDespLineOne]:
      'Suppression chambre particulière et médicaments non pris par le RO',
    [QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoDespLineOne]:
      'Suppression de la chambre particulière',
    [QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoDespLineTwo]:
      `Suppression des médicaments non pris par le régime obligatoire`,
    [QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoPlusDespLineOne]:
      `Suppression chambre particulière et médicaments non pris par le RO.`,
    [QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoPlusDespLineTwo]: `
      <span>Remboursement uniquement en 100% santé sur les postes Dentaire (sauf orthodontie) optique et auditif</span>
      <img src="assets/img/health100.png" loading="lazy" height="35px" alt="" />
      `,
  },
  YESNO_ENUM: {
    $ENUM_MAPPING: CommonModels.YesNoEnum,
    [CommonModels.YesNoEnum.No]: 'Non',
    [CommonModels.YesNoEnum.Yes]: 'Oui',
  },
  EMAILS_FROM_ENUM: {
    $ENUM_MAPPING: CommonModels.EmailsFrom,
    [CommonModels.EmailsFrom.noreply]: 'No reply',
    [CommonModels.EmailsFrom.GestionSante]: 'Gestion santé',
    [CommonModels.EmailsFrom.Courtier]: 'Courtier',
  },

  INSURERS_ENUM: {
    $ENUM_MAPPING: CommonModels.Insurers,
    [CommonModels.Insurers.Axa]: 'Axa',
    [CommonModels.Insurers.Generali]: 'Generali',
    [CommonModels.Insurers.SwissLife]: 'SwissLife',
    [CommonModels.Insurers.Miltis]: 'Miltis',
  },

  AGENCYEVENT_TYPE_ENUM: {
    $ENUM_MAPPING: TunnelSanteEventModels.AgencyEventType,
    [TunnelSanteEventModels.AgencyEventType.AgencyUpdatedEvent]:
      'Informations mises à jour',
    [TunnelSanteEventModels.AgencyEventType.AgencyApiCredentialsGeneratedEvent]:
      'génarétion de clef API',
    [TunnelSanteEventModels.AgencyEventType.AgencyContractGeneratedEvent]:
      'Génération du contrat',
    [TunnelSanteEventModels.AgencyEventType.AgencyContractSignedEvent]:
      'Signature du contrat',
    [TunnelSanteEventModels.AgencyEventType.AgencyDeletedEvent]:
      'Agence supprimée',
    [TunnelSanteEventModels.AgencyEventType.AgencyInSubscriptionArchivedEvent]:
      'Agence archivée',
    [TunnelSanteEventModels.AgencyEventType.AgencyUnarchivedEvent]:
      'Agence desarchivée',
    [TunnelSanteEventModels.AgencyEventType.AgeoBrokerFileCreatedEvent]:
      'Génération fichier Ageo',
    [TunnelSanteEventModels.AgencyEventType.CallBrokerEvent]: 'Appel  eloquant',
    [TunnelSanteEventModels.AgencyEventType.ReplyToAgencyEmailEvent]:
      'Réponse par email envoyée',
    [TunnelSanteEventModels.AgencyEventType.SendEmailToAgencyEvent]:
      "Envoi d'un email",
    [TunnelSanteEventModels.AgencyEventType.SubscriptionEditedEvent]:
      'Modification du contrat',
    [TunnelSanteEventModels.AgencyEventType.GenerateFileForAgencyPaymentEvent]:
      'Bordereaau généré',
    [TunnelSanteEventModels.AgencyEventType.SubBrokerArchivedEvent]:
      'Sous code archivé',
    [TunnelSanteEventModels.AgencyEventType.SubBrokersGeneratedEvent]:
      'Creation de sous code',
    [TunnelSanteEventModels.AgencyEventType.AgencyCommentCreatedEvent]:
      'Commentaire créé,',
    [TunnelSanteEventModels.AgencyEventType.LostPasswordForAgencyEvent]:
      'Mot de passe perdu',
    [TunnelSanteEventModels.AgencyEventType.MainBrokerEmailUpdatedEvent]:
      'Evnoi email reset mot de passe',
    [TunnelSanteEventModels.AgencyEventType.AgencyTransferredToEvent]:
      'Agence transférée',
    [TunnelSanteEventModels.AgencyEventType.AgencyTransferredFromEvent]:
      "Reception portefeuille d'une agence transférée",
    [TunnelSanteEventModels.AgencyEventType.MonthlyAgencySlipValidatedEvent]:
      'Bordereau validé',
    [TunnelSanteEventModels.AgencyEventType.MonthlyAgencySlipCreatedEvent]:
      'Bordereau créé',
    [TunnelSanteEventModels.AgencyEventType.MonthlyAgencySlipDeletedEvent]:
      'Bordereau supprimé',
    [TunnelSanteEventModels.AgencyEventType
      .HandlingBrokerSubscriptionCreatedEvent]:
      "Gestion de l'abonnement de courtier créé",
    [TunnelSanteEventModels.AgencyEventType.EmailAssignedToAgency]:
      'Email assigned to agency',
  },

  POLICYEVENT_TYPE_ENUM: {
    $ENUM_MAPPING: TunnelSanteEventModels.PolicyEventType,
    [TunnelSanteEventModels.PolicyEventType.Unknown]: '',
    [TunnelSanteEventModels.PolicyEventType.AddComplementToPolicyEvent]:
      'Ajouter un Complément',
    [TunnelSanteEventModels.PolicyEventType.AddMiscRefundEvent]:
      'Ajouter un remboursement divers',
    [TunnelSanteEventModels.PolicyEventType.AddRefundChequeNumbersEvent]:
      'Ajouter des numéros de chèque de remboursement',
    [TunnelSanteEventModels.PolicyEventType.AgeoSubscriptionCreatedEvent]:
      'Contrat Ageo créé',
    [TunnelSanteEventModels.PolicyEventType.AgeoSubscriptionFailedEvent]:
      'Erreur fonctionnelle création contrat Ageo',
    [TunnelSanteEventModels.PolicyEventType
      .AllowPaymentForTerminatedAutoPolicyEvent]:
      'Autoriser le paiement pour la police résiliée',
    [TunnelSanteEventModels.PolicyEventType.AvenantConfirmedEvent]:
      'Avenant confirmé',
    [TunnelSanteEventModels.PolicyEventType.AvenantHandledEvent]:
      'Avenant géré',
    [TunnelSanteEventModels.PolicyEventType
      .AvenantPaymentTransactionStartedEvent]:
      'Transaction de paiement Avenant commencée',
    [TunnelSanteEventModels.PolicyEventType.AvenantRequestRejectedEvent]:
      "Demande d'Avenant rejetée",
    [TunnelSanteEventModels.PolicyEventType.AvenantSavedEvent]:
      'Avenant enregistré',
    [TunnelSanteEventModels.PolicyEventType.AvenantValidatedEvent]:
      'Avenant validé',

    [TunnelSanteEventModels.PolicyEventType
      .ClaimRefundCreatedFromIms506FileEvent]:
      'Réclamer le remboursement créé à partir du fichier Ims 506',
    [TunnelSanteEventModels.PolicyEventType.CommentCreatedEvent]:
      'Commentaire créé',
    [TunnelSanteEventModels.PolicyEventType.ComplementDeletedEvent]:
      'Complément supprimé',

    [TunnelSanteEventModels.PolicyEventType
      .CreatedOrUpdatedSinisterWithFileEvent]:
      'Créé ou mis à jour Sinister avec fichier',
    [TunnelSanteEventModels.PolicyEventType.EditFragmentEvent]:
      'Modifier document',

    [TunnelSanteEventModels.PolicyEventType.HealthPolicyCreatedEvent]:
      'Police santé créée',
    [TunnelSanteEventModels.PolicyEventType.HealthPolicyUpdatedEvent]:
      'Police santé mise à jour',
    [TunnelSanteEventModels.PolicyEventType.HealthPropositionCreatedEvent]:
      'Proposition de santé créée',
    [TunnelSanteEventModels.PolicyEventType
      .HealthPropositionSignatureTransactionCreatedEvent]:
      'Transaction de signature de proposition de santé créée',
    [TunnelSanteEventModels.PolicyEventType.HealthPropositionSignedEvent]:
      'Proposition santé signée',
    [TunnelSanteEventModels.PolicyEventType.PaymentNotificationHandledEvent]:
      'Notification de paiement gérée',
    [TunnelSanteEventModels.PolicyEventType.PaymentOrderSentEvent]:
      'Ordre de paiement envoyé',
    [TunnelSanteEventModels.PolicyEventType.PolicyActivatedEvent]:
      'Police activée',
    [TunnelSanteEventModels.PolicyEventType.PolicyCreatedEvent]: 'Police créée',
    [TunnelSanteEventModels.PolicyEventType.PolicyNoticedEvent]:
      'Mise en demeure',
    [TunnelSanteEventModels.PolicyEventType.PolicyQuantiemeUpdatedEvent]:
      'Changement du jour de prélèvement',
    [TunnelSanteEventModels.PolicyEventType.PolicyRenewalProposedEvent]:
      'Renouvellement de la police proposé',
    [TunnelSanteEventModels.PolicyEventType.PolicyRenewalRejectedEvent]:
      'Renouvellement de la police rejeté',
    [TunnelSanteEventModels.PolicyEventType.PolicyRenewedEvent]:
      'Police renouvelée',
    [TunnelSanteEventModels.PolicyEventType.PolicySetAsCaducEvent]:
      'Police définie comme Caducité',
    [TunnelSanteEventModels.PolicyEventType.PolicySetAsNulliteEvent]:
      'Police définie comme Nullite',
    [TunnelSanteEventModels.PolicyEventType.PolicySuspendedEvent]:
      'Police suspendue',
    [TunnelSanteEventModels.PolicyEventType.PolicyTerminatedEvent]:
      'Police résiliée',
    [TunnelSanteEventModels.PolicyEventType.PolicyUpdatedPricingEvent]:
      'Tarification mise à jour',
    [TunnelSanteEventModels.PolicyEventType.PolicyUpdatedRiskEvent]:
      'Risque mis à jour',
    [TunnelSanteEventModels.PolicyEventType.PrelevementRejectedEvent]:
      'Prélévement rejeté',
    [TunnelSanteEventModels.PolicyEventType.ReceipPaidEvent]: 'Quittance payée',
    [TunnelSanteEventModels.PolicyEventType
      .ReceiptsPaymentNotificationHandledEvent]:
      'Notification de paiement de quittance gérée',
    [TunnelSanteEventModels.PolicyEventType
      .ReceiptsPendingRefundCancelledEvent]:
      'Quitances en attente de remboursement annulés',
    [TunnelSanteEventModels.PolicyEventType.RefundReceiptValidatedEvent]:
      'Quittance de remboursement validée',
    [TunnelSanteEventModels.PolicyEventType.RejectReceiptCanceled]:
      'Rejeter le Quittance annulée',
    [TunnelSanteEventModels.PolicyEventType.RemoveReceiptFeesEvent]:
      'Supprimer les frais de rejet',
    [TunnelSanteEventModels.PolicyEventType.SaveDocumentInformationsEvent]:
      'Enregistrer les informations du document',
    [TunnelSanteEventModels.PolicyEventType.SetAsFinGarantieProvisoireEvent]:
      'Mis en fin Garantie Provisoire',
    [TunnelSanteEventModels.PolicyEventType.SinisterUpdatedFromIms508FileEvent]:
      'Sinistre mis à jour à partir du fichier Ims 508',
    [TunnelSanteEventModels.PolicyEventType.PolicySmsSentEvent]: 'SMS envoyé',
    [TunnelSanteEventModels.PolicyEventType.TerminationRequestCancelledEvent]:
      'Demande de résiliation annulée',
    [TunnelSanteEventModels.PolicyEventType.TerminationRequestUpdatedEvent]:
      'Demande de résiliation mise à jour',
    [TunnelSanteEventModels.PolicyEventType.TerminationRequestUpsertedEvent]:
      'Demande de résiliation créée',
    [TunnelSanteEventModels.PolicyEventType.FileAddedToPolicyEvent]:
      'Fichier ajouté',
    [TunnelSanteEventModels.PolicyEventType.RefundForPolicyValidatedEvent]:
      'Remboursement validé',
    [TunnelSanteEventModels.PolicyEventType.PolicyCommentCreatedEvent]:
      'Commentaire créé',
    [TunnelSanteEventModels.PolicyEventType.ComplementCreatedEvent]:
      'Complément créé',
    [TunnelSanteEventModels.PolicyEventType.HealthContractPrintedEvent]:
      'Contrat santé imprimé',
    [TunnelSanteEventModels.PolicyEventType.HealthQuotationCreatedEvent]:
      'Devis santé créé',
    [TunnelSanteEventModels.PolicyEventType.PolicyBrokerSlipEvent]:
      'Police attachée à bordereau courtier',
    [TunnelSanteEventModels.PolicyEventType.AutomobileQuotationCreatedEvent]:
      'Devis auto créé',
    [TunnelSanteEventModels.PolicyEventType.PaymentErrorEvent]:
      'Paiement en erreur',
    [TunnelSanteEventModels.PolicyEventType
      .HealthDirectDebitPrelevementOperationEvent]:
      'Inegration Prelevement SmallTox',
    [TunnelSanteEventModels.PolicyEventType.PolicyTransferredEvent]:
      'Police transférée',
    [TunnelSanteEventModels.PolicyEventType.HealthPolicySyncRequestedEvent]:
      'Demande de synchro SmallTox',
    [TunnelSanteEventModels.PolicyEventType.StartReceiptTransactionEvent]:
      'Transaction de paiement quittance demarrée',
    [TunnelSanteEventModels.PolicyEventType
      .AgeoSubscriptionTechincalFailureEvent]:
      'Erreur technique création contrat Ageo',
    [TunnelSanteEventModels.PolicyEventType.StartComplementTransactionEvent]:
      'Transaction de paiement complément demarrée',
    [TunnelSanteEventModels.PolicyEventType.RopQuotationCreatedEvent]:
      "Génération du bulletin d'adhésion",
    [TunnelSanteEventModels.PolicyEventType.RopSignatureCreatedEvent]:
      'Début transaction signature électronique',
    [TunnelSanteEventModels.PolicyEventType.RopQuotationSignedEvent]:
      "Signature du bulletin d'adhésion",
    [TunnelSanteEventModels.PolicyEventType.RopPolicyCreatedEvent]:
      'Création de la police',
    [TunnelSanteEventModels.PolicyEventType.PolicySetAsNoEffectEvent]:
      'Mise en sans effet',
    [TunnelSanteEventModels.PolicyEventType
      .ActionCancelledBeforeAccountingEvent]: 'Annulation action avant compta',
    [TunnelSanteEventModels.PolicyEventType.DoublePaymentEvent]:
      'Double paiement police',
    [TunnelSanteEventModels.PolicyEventType.DoublePaymentReceiptEvent]:
      'Double paiement quittance',
    [TunnelSanteEventModels.PolicyEventType.RopSignatureOrderCreatedEvent]:
      'Ordre de signature créé',
    [TunnelSanteEventModels.PolicyEventType
      .QuotationSignatureTransactionCreatedEvent]:
      "Transaction de signature du bulletin d'adhésion initiée",
    [TunnelSanteEventModels.PolicyEventType.QuotationSmsSentEvent]:
      "SMS Bulletin d'adhésion envoyé",
    [TunnelSanteEventModels.PolicyEventType
      .PolicySignatureTransactionCreatedEvent]:
      'Signature des CP initiées par le client',
    [TunnelSanteEventModels.PolicyEventType.AutoPolicySignedEvent]:
      'Conditions particulières signées',
    [TunnelSanteEventModels.PolicyEventType.AutoSignatureOrderCreatedEvent]:
      'Conditions particulières en attente de signature',
    [TunnelSanteEventModels.PolicyEventType.HealthPolicyStatusForcedEvent]:
      'Changement de statut forcé',
    [TunnelSanteEventModels.PolicyEventType.PaymentSuccessEvent]:
      'Paiement effectué avec succès',
    [TunnelSanteEventModels.PolicyEventType.EmailAssignedToPolicy]:
      'Email attribué à la police',
    [TunnelSanteEventModels.PolicyEventType.EmailAssignedToAgency]:
      "Email attribué à l'agence",
    [TunnelSanteEventModels.PolicyEventType.HealthQuotationSignedEvent]:
      "Signature du bulletin d'adhésion",
    [TunnelSanteEventModels.PolicyEventType.TerminationInfoUpdatedEvent]:
      'Mise à jour des données résiliation',
    [TunnelSanteEventModels.PolicyEventType.PolicyPrelevementEvent]:
      'Prelevement effectué',
    [TunnelSanteEventModels.PolicyEventType.EmailAssignedToPolicyEvent]:
      'Email associé à la police',
    [TunnelSanteEventModels.PolicyEventType
      .HealthPolicyControlJobStatusUpdatedEvent]: 'Mis a jour statut controle',
    [TunnelSanteEventModels.PolicyEventType.AgeoContractReferenceUpdatedEvent]:
      'Mis a jour ref Ageo',
    [TunnelSanteEventModels.PolicyEventType.PolicyNotifiedForDocumentEvent]:
      'Police notifiée pour documents incomplets',
    [TunnelSanteEventModels.PolicyEventType.NotifyForDocumentPolicyEvent]:
      'Document de police créé',
  },

  POLICYACTION_TYPE_ENUM: {
    $ENUM_MAPPING: PolicyActionType,
    [PolicyActionType.CreationDuCompteClient]: 'Creation Du Compte Client',
    [PolicyActionType.PaiementDuComplement]: 'Paiement Du Complement',
    [PolicyActionType.ModificationDevis]: 'Modification Devis',
    [PolicyActionType.DepotDeDocument]: 'Depot De Document',
    [PolicyActionType.MiseEnGarantieProvisoire]: 'Mise En Garantie Provisoire',
    [PolicyActionType.ActivationDeLaPolice]: 'Activation De La Police',
    [PolicyActionType.PaiementQuittanceParPrelevement]:
      'Paiement Quittance Par Prelevement',
    [PolicyActionType.PaiementQuittanceParCB]: 'Paiement Quittance Par Cb',
    [PolicyActionType.Resiliation]: 'Resiliation',
    [PolicyActionType.MiseEnRejet]: 'Mise En Rejet',
    [PolicyActionType.ChangementQuantieme]: 'Changement Quantieme',
    [PolicyActionType.MiseEnDemeure]: 'Mise En Demeure',
    [PolicyActionType.Avenant]: 'Avenant',
    [PolicyActionType.Suspension]: 'Suspension',
    [PolicyActionType.RemiseEnActif]: 'Remise En Actif',
    [PolicyActionType.RemiseEnVigueur]: 'Remise En Vigueur',
    [PolicyActionType.ResiliationForNpp]: 'Resiliation For Npp',
    [PolicyActionType.Caducite]: 'Caducite',
    [PolicyActionType.Nullite]: 'Nullite',
    [PolicyActionType.FinGarantieProvisoire]: 'Fin Garantie Provisoire',
    [PolicyActionType.SuppressionFraisDeRejet]: 'Suppression Frais De Rejet',
    [PolicyActionType.PropositionRenouvellement]: 'Proposition Renouvellement',
    [PolicyActionType.RenouvellementRejeteParAssureur]:
      'Renouvellement Rejete Par Assureur',
    [PolicyActionType.RenouvellementDeLaPolice]: 'Renouvellement De La Police',
    [PolicyActionType.RemboursementClientVirement]:
      'Remboursement Client Virement',
    [PolicyActionType.QuittanceDeRemboursementAccepte]:
      'Quittance De Remboursement Accepte',
    [PolicyActionType.QuittanceDeRemboursementAnnule]:
      'Quittance De Remboursement Annule',
    [PolicyActionType.RemboursementClientChèque]: 'Remboursement Client Chèque',
    [PolicyActionType.RemboursementClientCB]: 'Remboursement Client Cb',
    [PolicyActionType.CreationRemboursementSinistreClientChèque]:
      'Creation Remboursement Sinistre Client Chèque',
    [PolicyActionType.CreationRemboursementSinistreClientVirement]:
      'Creation Remboursement Sinistre Client Virement',
    [PolicyActionType.MiseEnRejetDoublon]: 'Mise En Rejet Doublon',
    [PolicyActionType.PaiementQuittanceParPrelevementDoublon]:
      'Paiement Quittance Par Prelevement Doublon',
    [PolicyActionType.CreationDuCompteClientDoublon]:
      'Creation Du Compte Client Doublon',
    [PolicyActionType.CreationRemboursementRegularisation]:
      'Creation Remboursement Regularisation',
    [PolicyActionType.CreationPaiementRegularisation]:
      'Creation Paiement Regularisation',
    [PolicyActionType.AnnulationRejetSante]: 'Annulation Rejet Sante',
    [PolicyActionType.MiseAJourContractStartDate]:
      'Mise Ajour Contract Start Date',
    [PolicyActionType.ReversementRetentionPoliceSanté]:
      'Reversement Retention Police Santé',
    [PolicyActionType.VersementComptantPoliceSanté]:
      'Versement Comptant Police Santé',
    [PolicyActionType.RepriseVersementComptantPoliceSanté]:
      'Reprise Versement Comptant Police Santé',
    [PolicyActionType.VersementFraisDossierCourtierPoliceSanté]:
      'Versement Frais Dossier Courtier Police Santé',
    [PolicyActionType.VersementLineairePoliceSante]:
      'Versement Lineaire Police Sante',
    [PolicyActionType.FauxRejet]: 'Faux Rejet',
    [PolicyActionType.PaiementQuittanceParPrelevementFauxRejet]:
      'Paiement Quittance Par Prelevement Faux Rejet',
    [PolicyActionType.PaiementComplementAvenant]: 'Paiement Complement Avenant',
    [PolicyActionType.PropositionRenouvellementAvecAvenant]:
      'Proposition Renouvellement Avec Avenant',
    [PolicyActionType.CreationRemboursementMisc]: 'Creation Remboursement Misc',
    [PolicyActionType.FauxPrelevement]: 'Faux Prelevement',
    [PolicyActionType.RemboursementSinistreClientChèque]:
      'Remboursement Sinistre Client Chèque',
    [PolicyActionType.RemboursementSmallTox]: 'Remboursement Small Tox',
  },

  POLICYCANCELACTION_TYPE_ENUM: {
    $ENUM_MAPPING: CancelActionType,
    [CancelActionType.CancelActivation]: 'Annulation activation',
    [CancelActionType.CancelTempo]: 'Annulation tempo',
    [CancelActionType.CancelResil]: 'Annulation resil',
    [CancelActionType.CancelLastAvenant]: 'Annulation avenant',
    [CancelActionType.CancelLastRiskUpdate]: 'Annulation dernier risque en GP',
  },

  EMAIL_TYPE_ENUM: {
    $ENUM_MAPPING: EmailModels.EmailTypeEnum,
    [EmailModels.EmailTypeEnum.WelcomeBroker]: 'WelcomeBroker',
    [EmailModels.EmailTypeEnum.LostPassword]: 'LostPassword',
    [EmailModels.EmailTypeEnum.AgencyReply]: 'AgencyReply',
    [EmailModels.EmailTypeEnum.AckToBrokerContact]: 'AckToBrokerContact',
    [EmailModels.EmailTypeEnum.BrokerContract]: 'BrokerContract',
    [EmailModels.EmailTypeEnum.ClientAutomobileQuotation]:
      'ClientAutomobileQuotation',
    [EmailModels.EmailTypeEnum.ClientAutomobileAttestation]:
      'ClientAutomobileAttestation',
    [EmailModels.EmailTypeEnum.AgencyEmail]: 'AgencyEmail',
    [EmailModels.EmailTypeEnum.PolicyNoticeToBroker]: 'PolicyNoticeToBroker',
    [EmailModels.EmailTypeEnum.AckImsOfSinister]: 'AckImsOfSinister',
    [EmailModels.EmailTypeEnum.CustomerPaymentFileNotification]:
      'CustomerPaymentFileNotification',
    [EmailModels.EmailTypeEnum.CustomerRefundFileNotification]:
      'CustomerRefundFileNotification',
    [EmailModels.EmailTypeEnum.HealthCreditCardPaymentNotification]:
      'HealthCreditCardPaymentNotification',
    [EmailModels.EmailTypeEnum.WelcomeHandlingBroker]: 'WelcomeHandlingBroker',
    [EmailModels.EmailTypeEnum.CustomerRefundChequeLetterFileNotification]:
      'CustomerRefundChequeLetterFileNotification',
    [EmailModels.EmailTypeEnum.RopQuotationFiles]: 'RopQuotationFiles',
    [EmailModels.EmailTypeEnum.RopPolicyFiles]: 'RopPolicyFiles',
    [EmailModels.EmailTypeEnum.RopSignatureOrder]: 'RopSignatureOrder',
    [EmailModels.EmailTypeEnum.AutoSignatureOrder]: 'AutoSignatureOrder',
    [EmailModels.EmailTypeEnum.Relance]: 'Relance',
    [EmailModels.EmailTypeEnum.FinGarantieProvisoire]:
      'Fin Garantie Provisoire',
  },

  EMAILQUEUE_ENUM: {
    $ENUM_MAPPING: EmailModels.EmailQueueEnum,
    [EmailModels.EmailQueueEnum.NotCategorized]: 'Non catégorisé',
    [EmailModels.EmailQueueEnum.Résiliations]: 'Résiliations',
    [EmailModels.EmailQueueEnum.Sanseffet]: 'Sans effet',
    [EmailModels.EmailQueueEnum.Cartedetierspayant]: 'Carte de tiers payant',
    [EmailModels.EmailQueueEnum.Remboursement]: 'Remboursement',
    [EmailModels.EmailQueueEnum.Avenanttarifaire]: 'Avenant tarifaire',
    [EmailModels.EmailQueueEnum.Avenantnontarifaire]: 'Avenant non tarifaire',
    [EmailModels.EmailQueueEnum.ChangementdeRIB]: 'Changement de RIB',
    [EmailModels.EmailQueueEnum.Cotisation]: 'Cotisation',
    [EmailModels.EmailQueueEnum.DemandeCourtier]: 'Demande courtier',
    [EmailModels.EmailQueueEnum.Réclamation]: 'Réclamation',
    [EmailModels.EmailQueueEnum.Reportdedate]: 'Report de date',
    [EmailModels.EmailQueueEnum.Retoursdepièces]: 'Retours de pièces',
    [EmailModels.EmailQueueEnum.Télétransmission]: 'Télétransmission',
    [EmailModels.EmailQueueEnum.AvenantChangementVehicule]:
      'Avenant changement vehicule',
    [EmailModels.EmailQueueEnum.AvenantChangementFractionnement]:
      'Avenant changement fractionnement',
  },

  SUBSTATUS_ENUM: {
    $ENUM_MAPPING: SubStatus,
    [SubStatus.ERROR]: 'Erreur',
    [SubStatus.INPUT_ERROR]: 'Erreur de saisie',
    [SubStatus.CUSTOMER_REQUEST]: 'Demande du client',
    [SubStatus.SUPPLIER_REQUEST]:
      "Changement de politique d'acceptation des risques par l'assureur",
    [SubStatus.RETAILER_REQUEST]: 'Demande du courtier',
    [SubStatus.DUPLICATE]: 'Doublon',
    [SubStatus.NON_PAYMENT]: 'Non-paiement',
    [SubStatus.CLAIM]: "Survenance d'un sinistre ou fréquence de sinistres",
    [SubStatus.BARGAIN_CHANGE]: 'Changement de risque',
    [SubStatus.HOUSE_MOVING]: 'Déménagement',
    [SubStatus.MUTUAL_MANDATORY]: 'Mutuelle obligatoire',
    [SubStatus.OTHERS]: 'Autres',
    [SubStatus.SUPPLIER_DUE]: 'Echéance Assureur',
    [SubStatus.CUSTOMER_DUE]: 'Echéance Client',
    [SubStatus.MARITAL_STATUS_CHANGE]: 'Changement de stituation familiale',
    [SubStatus.CUSTOMER_REQUEST_TERMINATE_OTHERS_CONTRACTS]:
      "Demande client suite à la résiliation d'autres contrats",
    [SubStatus.AGREEMENT]: 'ACCORD',
    [SubStatus.MISSTATEMENT]: 'DÉCLARATION INEXACTE',
    [SubStatus.MISSING_DOCUMENTARY_EVIDENCE]:
      'Non Présentation de justificatifs',
    [SubStatus.SELL_VEHICLE]: 'Vente de véhicule',
    [SubStatus.BENEFICIARY_CMU]: 'Bénéficiaire CMU',
    [SubStatus.RATING_INCREASE]: 'Augmentation de tarif',
    [SubStatus.RISK_OUT]: 'Disparition du risque',
    [SubStatus.MULTIPLE_PAYMENT_INCIDENTS]: 'Incidents répétitifs de paiement',
    [SubStatus.WRONG_DECLARATION]:
      "Non respet par l'assuré de ses obligations précontractuelles ou contractuelles",
    [SubStatus.LAW_HAMON]: 'LOI HAMON',
    [SubStatus.CMU]: 'Couverture maladie universelle (CMU)',
    [SubStatus.ACS]: "Aide au paiement d'une complémentaire Santé(ACS)",
    [SubStatus.DEATH]: 'Dècès',
    [SubStatus.MIGRATION]: 'Migré',
    [SubStatus.RETIREMENT]: 'Départ en retraite',
    [SubStatus.REPORT]: 'Sans effet report',
    [SubStatus.SUB_ANNUAL_TERMINATION]: 'Résiliation infra annuelle',
    [SubStatus.ACTIVITY_TERMINATE]: "Fin de l'activité",
    [SubStatus.LACK_OF_STAFF]: 'Manque de personnel',
  },

  ACCOUNNTKIND_ENUM: {
    $ENUM_MAPPING: AccountKind,
    [AccountKind.Broker]: 'Broker',
    [AccountKind.Client]: 'Client',
    [AccountKind.BackOffice]: 'BackOffice',
  },

  ACCOUNT_STATUS_ENUM: {
    $ENUM_MAPPING: AccountStatus,
    [AccountStatus.Offline]: 'Offline',
    [AccountStatus.Online]: 'Online',
  },

  BANNKREJECTREASONS_ENUM: {
    $ENUM_MAPPING: BankRejectReasons,
    [BankRejectReasons.IncorrectAccountNumber]:
      "Coordonnées bancaires incorrectes: IBAN/BIC incorrecte ou le compte n'est pas en euro.",
    [BankRejectReasons.InvalidCreditorAccountNumber]:
      'Numéro de compte créancier invalide',
    [BankRejectReasons.ClosedAccountNumber]: 'Compte clôturé',
    [BankRejectReasons.BlockedAccount]: 'Opposition sur compte / Compte bloqué',
    [BankRejectReasons.InvalidDebtorAccountType]:
      'Type de compte débiteur invalide',
    [BankRejectReasons.InvalidAgent]:
      "Un agent dans la chaîne de paiement n'est pas valable.",
    [BankRejectReasons.AccountDetailsChanged]:
      'Les détails du compte ont changé.',
    [BankRejectReasons.AccountInSequestration]: 'Le compte est sous séquestre.',
    [BankRejectReasons.AccountInLiquidation]: 'Le compte est en liquidation.',
    [BankRejectReasons.TransactionForbidden]:
      'Opération interdite sur ce type de compte',
    [BankRejectReasons.InvalidBankOperationCode]: 'Code opération incorrect',
    [BankRejectReasons.ZeroAmount]: 'Montant à zéro',
    [BankRejectReasons.NotAllowedAmount]:
      'Montant supérieur au maximum autorisé',
    [BankRejectReasons.NotAllowedCurrency]: 'Devise non autorisée',
    [BankRejectReasons.InsufficientFunds]: 'Fonds insuffisants',
    [BankRejectReasons.Duplication]: 'Doublon',
    [BankRejectReasons.TooLowAmount]: 'Montant inférieur au minimum autorisé',
    [BankRejectReasons.BlockedAmount]: 'Montant bloqué',
    [BankRejectReasons.WrongAmount]: 'Montant incorrect',
    [BankRejectReasons.InvalidControlSum]: 'Somme de contrôle invalide',
    [BankRejectReasons.AlreadyReturnedTransaction]:
      'Transaction déjà retournée',
    [BankRejectReasons.InconsistenWithEndCustomer]:
      'Incohérent par rapport au client final',
    [BankRejectReasons.MissingCreditorAddress]:
      'Adresse du créancier manquante',
    [BankRejectReasons.UnrecognisedInitiatingParty]: 'Emetteur non reconnu',
    [BankRejectReasons.UnknownEndCustomer]: 'Client final inconnu',
    [BankRejectReasons.MissingDebtorAddress]: 'Adresse ou dette manquante',
    [BankRejectReasons.BankError]: "Renvoyé à la suite d'une erreur bancaire.",
    [BankRejectReasons.AuthorisationCancelled]: "L'autorisation est annulée.",
    [BankRejectReasons.CreditorBankIsNotRegistered]:
      'La banque créancière n’est pas agréée',
    [BankRejectReasons.IncorrectCurrency]: 'Devise incorrecte',
    [BankRejectReasons.RequestedByCustomer]: 'Demandé par le client',
    [BankRejectReasons.DebtorBankIsNotRegistered]:
      'Dette ou la banque n’est pas agréée',
    [BankRejectReasons.ReturnForTechnicalReason]:
      'Retour suite à des problèmes techniques ayant entraîné une transaction erronée.',
    [BankRejectReasons.InvalidDate]: 'Date invalide',
    [BankRejectReasons.CorrespondentBankNotPossible]:
      'Banque correspondante non possible',
    [BankRejectReasons.BalanceInfoRequest]:
      'Requête sur les informations du solde',
    [BankRejectReasons.SettlementFailed]: 'Règlement échoué',
    [BankRejectReasons.EmvLiabilityShift]: 'Transfert de responsabilité EMV',
    [BankRejectReasons.EriOptionNotSupported]:
      "L'option Extended Remittance Information (ERI) n'est pas prise en charge.",
    [BankRejectReasons.InvalidFormat]: 'Format invalide',
    [BankRejectReasons.InvalidLocalInstrumentCode]:
      'Type de prélèvement incorrect',
    [BankRejectReasons.FollowingCancellationRequest]:
      'Requête suivant une annulation',
    [BankRejectReasons.Fraud]: "Retourné à la suite d'une fraude.",
    [BankRejectReasons.FinalResponseMandateCancelled]:
      'La réponse finale/le suivi est rappelé lorsque le mandat est annulé.',
    [BankRejectReasons.NoMandate]: 'Absence de mandat',
    [BankRejectReasons.MissingMandatoryInformationInMandate]:
      'Données mandat manquantes ou incorrectes',
    [BankRejectReasons.RefundRequestByEndCustomer]:
      'Opération contestée par le débiteur',
    [BankRejectReasons.EndCustomerDeceased]: 'Titulaire décédé',
    [BankRejectReasons.NotSpecifiedReasonCustomerGenerated]:
      'Refus du destinataire - raison non communiquée',
    [BankRejectReasons.NotSpecifiedReasonAgentGenerated]:
      'Raison non communiquée',
    [BankRejectReasons.Narrative]: 'Narratif',
    [BankRejectReasons.NoAnswerFromCustomer]: 'Pas de réponse du client',
    [BankRejectReasons.NotCompliant]:
      "Le compte du client n'est pas conforme aux exigences réglementaires, par exemple la FICA (en Afrique du Sud) ou toute autre exigence réglementaire qui rend un compte inactif pour certains traitements.",
    [BankRejectReasons.NoOriginalTransactionReceived]:
      'Pas de transaction originale reçue',
    [BankRejectReasons.PinLiabilityShift]: 'Transfert de responsabilité PIN',
    [BankRejectReasons.BankIdentifierIncorrect]: 'Code banque incorrect',
    [BankRejectReasons.InvalidCreditorBicIdentifier]:
      'Identifiant BIC du créancier invalide',
    [BankRejectReasons.NotUniqueTransactionReference]:
      'Référence de transaction non unique',
    [BankRejectReasons.MissingDebtorAccountOrIdentification]:
      'Motif réglementaire - compte du débiteur nécessaire',
    [BankRejectReasons.MissingDebtorNameOrAddress]:
      'Motif réglementaire - nom du débiteur nécessaire',
    [BankRejectReasons.MissingCreditorNameOrAddress]:
      'Motif réglementaire - nom du créancier nécessaire',
    [BankRejectReasons.RegulatoryReason]: 'Motif réglementaire',
    [BankRejectReasons.ReturnUponUnableToApply]:
      "Retour suite à une demande d'enquête et aucune réparation possible.",
    [BankRejectReasons.SpecificServiceOfferedByDebtorAgent]:
      'Service spécifique proposé par la banque du débiteur',
    [BankRejectReasons.SpecificServiceOfferedByCreditorAgent]:
      'Service spécifique offert par la banque du créancier',
    [BankRejectReasons.CreditorNotOnWhitelistOfDebtor]:
      'Compte du créancier absent de la whitelist du débiteur.',
    [BankRejectReasons.CreditorOnBlacklistOfDebtor]:
      'Compte du créancier présent sur la blacklist du débiteur.',
    [BankRejectReasons.MaximumNumberOfDirectDebitTransactionsExceeded]:
      "Nombre d'opération de prélèvement maximum autorisé par la banque du débiteur.",
    [BankRejectReasons.MaximumDirectDebitTransactionAmountExceeded]:
      'Nombre de transaction maximum autorisé par la banque du débiteur.',
    [BankRejectReasons.PaymentStopped]:
      'Le paiement est arrêté par le titulaire du compte.',
    [BankRejectReasons.PreviouslyStopped]:
      "Précédemment arrêté au moyen d'un avis d'arrêt de paiement.",
    [BankRejectReasons.ServiceNotRendered]: 'Service non rendu',
    [BankRejectReasons.CutOffTime]: "Fichier reçu après l'heure limite",
    [BankRejectReasons.RemovedFromTracking]:
      "Le retour à la suite d'un prélèvement automatique est retiré du processus de suivi.",
    [BankRejectReasons.UnduePayment]: 'Le paiement est injustifié',
    [BankRejectReasons.UnknownReason]: 'Raison inconnue.',
  },

  INVALID_SS_NUMBER_REASONS_ENUM: {
    $ENUM_MAPPING: ErrorCode.InvalidSSNumberReasons,
    [ErrorCode.InvalidSSNumberReasons.InvalidFirstCharacter]:
      'Le premier chiffre doit obligatoirement être 1, 2, 3, 4, 5 , 6, 7 ou 8',
    [ErrorCode.InvalidSSNumberReasons.Invalid4And5Characters]:
      '4ème et 5ème chiffres ne peut être 00',
    [ErrorCode.InvalidSSNumberReasons.Invalid6And7Characters]:
      '6ème et 7ème chiffres ne peut être 00',
    [ErrorCode.InvalidSSNumberReasons.MismatchSexe]:
      'Inadéquation sexe / numéro sécurité sociale',
    [ErrorCode.InvalidSSNumberReasons.MismatchBirthdayMonth]:
      'Inadéquation mois de naissance / numéro sécurité sociale',
    [ErrorCode.InvalidSSNumberReasons.MismatchBirthdayYear]:
      'Inadéquation année de naissance / numéro sécurité sociale',
  },
};
